/**
 * 作者：vvyng@qq.com
 * 时间：2021-05-28
 */
import it from "element-ui/src/locale/lang/it";
import qs from 'qs';

// 取回cookie
export function getCookie(name) {
  let arr;
  let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg)) {
    return unescape(arr[2]);
  } else {
    return null;
  }
}

// 删除cookie
export function delCookie(name) {
  setCookie(name, ' ', -1);
}

function firstToUpper(str) {
  return str.trim().replace(str[0], str[0].toUpperCase());
}

// 驼峰转换下划线
function toLine(name) {
  return name.replace(/([A-Z])/g, "_$1").toLowerCase();
}

export function getStockAuthorityKey(prefix, stockType) {
  stockType = stockType || '';
  prefix = prefix || '';
  return prefix + firstToUpper(toHump(stockType));
}

function leftPad(s, len, pad) {
  while (s.length < len) {
    s = pad + s;
  }
  return s;
}

/* 接口链接 */
export function interfaceFn(obj) {
	var interfaceUrl = '';//apk-exe打包需写全
	// interfaceUrl = 'http://eye.ypos.vip';
	// interfaceUrl = 'http://zmd.ypos.vip';
	if (obj) {
		// interfaceUrl = 'http://eye.ypos.vip';
		interfaceUrl = 'http://zmd.ypos.vip';
	}
	return interfaceUrl;
}

function getAgeFromBirthday (birthday) {
  var yearBorn = birthday.getFullYear();
  var monthBorn = birthday.getMonth();
  var dayBorn = birthday.getDate();
  var nowDate = new Date();
  var year = nowDate.getFullYear();
  var month = nowDate.getMonth();
  var day = nowDate.getDate();
  var hour = nowDate.getHours();
  //间隔的年、月、日
  var yL = year - yearBorn;
  var mL = month - monthBorn;
  var dL = day - dayBorn;
  //统一的，计算间隔了XX年XX月XX天的方法。对日、月需要考虑借位的问题，年间隔一定>=0，所以不用考虑。这样一共有4种可能
  if (dL < 0 ) {
    dL = dL + getMonthDays(monthBorn + 1 , yearBorn);//日不够减，向月借位。借哪个月的天数这里有点绕，看图解
    mL = mL - 1;
    if (mL < 0) {
      mL = mL + 12;//月向年借位
      yL = yL - 1;
    }
  } else {
    if (mL < 0) {
      mL = mL + 12;//月向年借位
      yL = yL - 1;
    }
  }

  //显示
  let yStr = "";
  let mStr = "";
  let dStr = "";
  let hStr = "";
  if (yL > 0) yStr = yL + "岁";
  if (mL > 0) mStr = (mL > 10 ? mL : '0' + mL) + "月";
  if (dL > 0) dStr = (dL > 10 ? dL : '0' + dL) + "天";
  if (yL == 0 && mL == 0 && dL == 0) hStr = hour + '小时';
  if ( yL < 0 || (yL == 0 && mL < 0) || (yL == 0 && mL == 0 && dL < 0)) return "这是未来的日期！";
  return yStr + mStr + dStr + hStr;
}
//计算月的天数的函数
//31天的月: 1，3，5，7，8，10，12:2月较特殊:平年28天，闰年（被4整除）29天;30天的月:其余所有月
function getMonthDays (month, year) {
  let mDays;
  if (month == 1 || month == 3 || month == 5 || month == 7 || month == 8 || month == 10 || month == 12) {
    mDays = 31;
  } else if (month == 2) {
    if (year % 4 == 0) {
      mDays = 29;
    } else {
      mDays = 28;
    }
  } else {
    mDays = 30;
  }
  return mDays;
};
// 计算年龄
export function getAge (birthYearMonthDay) {
  if (!birthYearMonthDay) return;
  let hasList = birthYearMonthDay.substr(0, 10);
  let birthDayArray = hasList.split('-');
  let birthDay = new Date(birthDayArray[0], birthDayArray[1] - 1, birthDayArray[2]);//由于JS中月份的底层是数组，需要真实的月份-1构造出来的日期才是正确的
  return getAgeFromBirthday(birthDay);
}

/**
 *
 * @param memberCouponList
 * @param orderAmount 整单金额(未减整单优惠（orderDiscountAmount）的金额)
 * @param goodsList
 * @param orderDiscountAmount 整单优惠（比优惠券优先计算的整单优惠，例如整单满减优惠，计算是否满足优惠券的使用，需要减去这部分优惠再进行判断） 按金额比例分摊
 */
export function checkCoupon(memberCouponList, orderAmount, goodsList, orderDiscountAmount) {
  // 计算是否可用
  if (!memberCouponList) {
    return;
  }
  if (memberCouponList.length == 0) {
    return;
  }
  memberCouponList.forEach(coupon => {
    coupon.selected = false;
    coupon.enable = !coupon.state;
  });
  if (orderAmount <= 0) {
    return;
  }
  assignFullPromotionAmount(goodsList, orderAmount, orderDiscountAmount)
  let now = timeFn(1, new Date());
  let weekDay = new Date().getDay();
  if (weekDay == 0) {
    weekDay = 7;
  }
  weekDay = weekDay + '';
  let moneyDay = parseInt(now.split("-")[2]) + '';
  let timeStr = timeFn(6).split(":");
  let time = timeStr[0] + timeStr[1];
  memberCouponList.forEach(coupon => {
    coupon.selected = false;
    coupon.discountAmount = 0;
    if (!coupon.enable) {
      return;
    }
    // 实体
    if (!coupon.wechatCoupon.isPhysical) {
      coupon.enable = false;
      return;
    }
    let totalAmount = orderAmount || 0;
    // 先判断 整单金额 是否满足
    if (coupon.wechatCoupon.preferentialCondition
      && coupon.wechatCoupon.preferentialCondition > totalAmount) {
      coupon.enable = false;
      return;
    }
    // 判断时间 是否 符合
    if (timeFn(1, coupon.expireTime) < now) {
      coupon.enable = false;
      return;
    }
    if (timeFn(1, coupon.wechatCoupon.beginTime) > now) {
      coupon.enable = false;
      return;
    }

    // 禁用日期
    if (coupon.wechatCoupon.unUsableDate &&
      coupon.wechatCoupon.unUsableDate.indexOf(now) >= 0) {
      coupon.enable = false;
    }

    // 可用日期
    if (coupon.wechatCoupon.usableCycle && coupon.wechatCoupon.usableDate) {
      let usableDate = coupon.wechatCoupon.usableDate.split(",");
      let set = new Set(usableDate);
      if (1 == coupon.wechatCoupon.usableCycle) {
        // 每周 1,2,3,4,5,6,7
        coupon.enable = set.has(weekDay);
      } else {
        // 每月
        coupon.enable = set.has(moneyDay);
      }
    }
    if (!coupon.enable) {
      return;
    }
    // 可用时段 0:00-9:59,16:00-23:59

    if (coupon.wechatCoupon.usableTime) {
      let usableTime = coupon.wechatCoupon.usableTime.split(",");
      let flag = false;
      usableTime.forEach(rangeTime => {
        if (flag) {
          return;
        }
        let t = rangeTime.split("-");
        let startT = t[0].split(":");
        let endT = t[1].split(":");
        let start = parseInt(leftPad(startT[0], 2, "0")
          + leftPad(startT[1], 2, "0"));
        let end = parseInt(leftPad(endT[0], 2, "0")
          + leftPad(endT[1], 2, "0"));
        flag = time >= start && time <= end;
      })
      coupon.enable = flag;
    }
    if (!coupon.enable) {
      return;
    }

    // 判断商品分类是否满足
    let isMatch = false;
    goodsList = goodsList || [];
    let maxTotalAmount = 0;
    let amountMap = new Map();
    switch (coupon.wechatCoupon.couponType) {
      case 3: // 单品现金券
      case 6: // 单品商品折扣券
        // 判断品类的金额是否符合
        totalAmount = 0;
        isMatch = false;
        goodsList.forEach(g => {
          if (g.commodityId == coupon.wechatCoupon.productId) {
            isMatch = true;
            totalAmount = totalAmount + g.amount - g._fullPromotionAmount;
          }
        });
        amountMap.set('g_' + coupon.wechatCoupon.couponType + '_' + coupon.wechatCoupon.productId, totalAmount);
        if (!isMatch) {
          coupon.enable = false;
          break;
        }
        if (coupon.wechatCoupon.preferentialCondition
          && (coupon.wechatCoupon.preferentialCondition > totalAmount)) {
          coupon.enable = false;
          break;
        }
        coupon.enable = true;
        break;
      case 2: // 品类商品现金券
      case 5: // 品类商品折扣券
        // 判断品类的金额是否符合
        totalAmount = 0;
        goodsList.forEach(g => {
          let categoryIds = coupon.wechatCoupon.categoryIds.split(",");
          let set = new Set(categoryIds);
          if (set.has(g.bigCategoryId + '')) {
            isMatch = true;
            totalAmount = totalAmount + g.amount - g._fullPromotionAmount;
          }
        });
        if (!isMatch) {
          coupon.enable = false;
          break;
        }
        if (coupon.wechatCoupon.preferentialCondition
          && (coupon.wechatCoupon.preferentialCondition > totalAmount)) {
          coupon.enable = false;
          break;
        }
        amountMap.set('c_' + coupon.wechatCoupon.couponType + '_' + coupon.wechatCoupon.categoryIds, totalAmount);
        coupon.enable = true;
        break;
      case 1: // 全部商品现金券
      case 4: // 全部商品折扣券
        coupon.enable = true;
        break;
      case 7: // 单品兑换券

        let goods = goodsList.find(goods => goods.amount > 0 && goods.commodityId == coupon.wechatCoupon.productId);
        coupon.enable = goods ? true : false;
        break;
      case 8:
        coupon.isGiftCoupon = true;
        coupon.wechatCoupon.isGiftCoupon = true;
        coupon.enable = coupon.balanceAmount > 0;
        break;
      default:
        coupon.enable = false;
        break;
    }
    if (!coupon.enable) {
      return;
    }
    let amount;
    switch (coupon.wechatCoupon.couponType) {
      case 1: // 全部商品现金券
      case 2: // 品类商品现金券
      case 3: // 单品现金券
        coupon.discountAmount = Number(coupon.wechatCoupon.preferential);
        break;
      case 4: // 全部商品折扣券
        coupon.discountAmount = Number((orderAmount * (1 - coupon.wechatCoupon.preferential)).toFixed(2));
        break;
      case 5: // 品类商品折扣券
        amount = amountMap.get('c_' + coupon.wechatCoupon.couponType + '_' + coupon.wechatCoupon.categoryIds) || 0;
        coupon.discountAmount = Number((amount * (1 - coupon.wechatCoupon.preferential)).toFixed(2));
        break;
      case 6: // 单品商品折扣券
        amount = amountMap.get('g_' + coupon.wechatCoupon.couponType + '_' + coupon.wechatCoupon.productId) || 0;
        coupon.discountAmount = Number((amount * (1 - coupon.wechatCoupon.preferential)).toFixed(2));
        break;
      case 7: // 单品兑换券
        coupon.discountAmount = 0;
        break;
      case 8: // 单品兑换券
        coupon.isGiftCoupon = true;
        coupon.discountAmount = coupon.balanceAmount;
        break;
      default:
        coupon.discountAmount = 0;
    }
  })
  memberCouponList.forEach(coupon => {
    coupon._discountAmount = coupon.discountAmount;
  });
  // 排序
  memberCouponList.sort((c1, c2) => {
    if (c1.isGiftCoupon && c2.isGiftCoupon) {
      return c1.discountAmount - c2.discountAmount;
    }
    if (c1.isGiftCoupon) {
      return -1;
    }
    if (c2.isGiftCoupon) {
      return 1;
    }
    return c2.discountAmount - c1.discountAmount;
  })

}

function assignGoodsCoupon(discountAmount, g, c) {
  //分配优惠金额到商品
  let temp = g._maxCoupon - g._coupon;
  if (temp <= 0) {
    // 不能再分配
    return discountAmount;
  }
  if (temp >= discountAmount) {
    // 可全部分配
    g._coupon = g._coupon + discountAmount;
    discountAmount = 0;
  } else {
    // 只满足部分
    g._coupon = g._maxCoupon;
    discountAmount = discountAmount - temp;
  }
  return discountAmount;
}

function assignFullPromotionAmount(goodsList, orderAmount, orderDiscountAmount, coupon7List) {
  goodsList.forEach(g => {
    g._fullPromotionAmount = 0;
    g._coupon = g._coupon || 0;
    g._amount = g.amount - g._coupon;
  });

  if (orderDiscountAmount > 0) {
    orderAmount = orderAmount - orderDiscountAmount;
    if (orderAmount <= 0) {
      return;
    }
    // 计算兑换的金额
    let couponAmount = 0;
    goodsList.forEach(g => {
      couponAmount = couponAmount + g._coupon;
    })
    orderAmount = Number((orderAmount - couponAmount).toFixed(2));
    // 分摊整单优惠
    if (orderAmount <= orderDiscountAmount) {
      // 全部都是
      orderDiscountAmount = orderDiscountAmount - orderAmount;
      orderAmount = 0;
      goodsList.forEach(g => {
        g._fullPromotionAmount = g._amount;
      })
    }
    if (orderAmount > 0) {
      let rate = Number((orderDiscountAmount / orderAmount).toFixed(3));
      let max = {_amount: 0};
      goodsList.forEach(g => {
        g._fullPromotionAmount = Number((g._amount * rate).toFixed(2));
        if (g._amount > max._amount) {
          max = g;
        }
        if (orderDiscountAmount >= g._fullPromotionAmount) {
          orderDiscountAmount = Number((orderDiscountAmount - g._fullPromotionAmount).toFixed(2));
        } else {
          g._fullPromotionAmount = orderDiscountAmount;
          orderDiscountAmount = 0;
        }
      })
      if (orderDiscountAmount > 0) {
        // 剩余的分配给金额最大的那个
        let diff = max._amount - max._fullPromotionAmount;
        if (diff > orderDiscountAmount) {
          max._fullPromotionAmount = Number((max._fullPromotionAmount + orderDiscountAmount).toFixed(2));
          orderDiscountAmount = 0;
        } else {
          orderDiscountAmount = orderDiscountAmount - diff;
          max._fullPromotionAmount = max._amount;
        }
      }
    }
    if (orderDiscountAmount > 0) {
      // 重新分配给 兑换的商品
      // 分摊整单优惠
      let rate = Number((orderDiscountAmount / couponAmount).toFixed(3));
      let max = {_coupon: 0};
      goodsList.forEach(g => {
        if (!g._coupon) {
          return;
        }
        let diff = Number((g._coupon * rate).toFixed(2));
        if (g._coupon > max._coupon) {
          max = g;
        }
        if (orderDiscountAmount >= diff) {
          orderDiscountAmount = Number((orderDiscountAmount - diff).toFixed(2));
          g._fullPromotionAmount = g._fullPromotionAmount + diff;
        } else {
          g._fullPromotionAmount = g._fullPromotionAmount + orderDiscountAmount;
          orderDiscountAmount = 0;
        }
      })
      if (orderDiscountAmount > 0) {
        // 剩余的分配给金额最大的那个
        max._fullPromotionAmount = Number((max._fullPromotionAmount + orderDiscountAmount).toFixed(2));
      }
    }
  }
  // 重新设置优惠券的优惠金额
  goodsList.forEach(g => {
    g._maxCoupon = g.amount - g._fullPromotionAmount; // 最大可优惠金额
    if (g._coupon > g._maxCoupon) {
      g._coupon = g._maxCoupon;
    }
    if (g._coupon > 0 && coupon7List != null && coupon7List.length > 0) {
      let exchangeQty = g.exchangeQty;
      let couponAmount = Number((g._coupon / g.exchangeQty).toFixed(2));
      let diff = g._coupon - Number((couponAmount * exchangeQty).toFixed(2));
      diff = Number(diff.toFixed(2));
      coupon7List.forEach(c => {
        if (!c.selected) {
          return;
        }
        if (!(exchangeQty > 0)) {
          return;
        }
        if (c.wechatCoupon.productId == g.commodityId) {
          c._discountAmount = couponAmount;
          exchangeQty = exchangeQty - 1;
          if (diff != 0 && exchangeQty == 0) {
            c._discountAmount = c._discountAmount + diff;
          }
        }
      })
    }
  });

}

// 计算优惠金额
export function sumCoupon(couponList, goodsList, orderAmount, fullPromotionAmount) {
  orderAmount = Number(orderAmount);
  fullPromotionAmount = Number(fullPromotionAmount);
  // 计算叠加后的优惠金额
  goodsList.forEach(g => {
    g._coupon = 0; // 优惠金额
    g.exchangeQty = 0;
    g._fullPromotionAmount = 0;
    g._maxCoupon = g.amount - g._fullPromotionAmount; // 最大可优惠金额
  })
  orderAmount = Number(orderAmount.toFixed(2));

  // 兑换金额计算
  // 判断是否有兑换
  let coupon7List = couponList.filter(c => c.wechatCoupon.couponType == 7);
  if (coupon7List && coupon7List.length > 0) {
    // 查找要兑换的商品
    let couponAmount = 0;
    coupon7List.forEach(c => {
      c._discountAmount = 0;
      c.selected = false;
      goodsList.forEach(itemDto => {
        if (c.wechatCoupon.productId == itemDto.commodityId
          && (itemDto.qty - itemDto.exchangeQty) >= 0) {
          itemDto.exchangeQty = itemDto.exchangeQty + 1;
          c.discountAmount = itemDto.price;
          c._discountAmount = c.discountAmount;
          couponAmount = couponAmount + c.discountAmount;
          c.selected = true;
          itemDto._coupon = itemDto._coupon + c.discountAmount;
          itemDto._fullPromotionAmount = 0;
        }
      })
    })
  }
  assignFullPromotionAmount(goodsList, orderAmount + fullPromotionAmount, fullPromotionAmount, coupon7List);


  // 先计算相同优惠券叠加后满足金额不能超过商品的金额
  if (true) {
    //相同的coupon 满足金额要叠加计算
    let preferentialMap = new Map();
    let amountMap = new Map();
    couponList.forEach(c => {
      if (c.wechatCoupon.couponType == 7) {
        return;
      }
      c._discountAmount = 0;
      if (!c.wechatCoupon.preferentialCondition) {
        // 不限金额
        return;
      }

      let key = 'coupon_' + c.wechatCoupon.id;
      let preferentialCondition = preferentialMap.get(key);
      preferentialCondition = preferentialCondition || 0;
      preferentialCondition = preferentialCondition + Number(c.wechatCoupon.preferentialCondition);
      preferentialMap.set(key, Number(preferentialCondition.toFixed(2)));
      if (amountMap.has(key)) {
        return;
      }
      goodsList.forEach(g => {
        // 单品
        if ((c.wechatCoupon.couponType == 3
          || c.wechatCoupon.couponType == 6)
          && g.commodityId
          && g.commodityId == c.wechatCoupon.productId) {
          let amount = amountMap.get(key);
          amount = amount || 0;
          amount = amount + g._maxCoupon;
          amountMap.set(key, amount);
        }
        // 品类
        if ((c.wechatCoupon.couponType == 2
          || c.wechatCoupon.couponType == 5)
          && g.bigCategoryId
          && c.wechatCoupon.categoryIds) {
          let categoryIds = c.wechatCoupon.categoryIds.split(",");
          let set = new Set(categoryIds);
          if (set.has(g.bigCategoryId + '')) {
            let amount = amountMap.get(key);
            amount = amount || 0;
            amount = amount + g._maxCoupon;
            amountMap.set(key, amount);
          }
        }
        // 全部商品
        if ((c.wechatCoupon.couponType == 1
          || c.wechatCoupon.couponType == 4)) {
          let amount = amountMap.get(key);
          amount = amount || 0;
          amount = amount + g._maxCoupon;
          amountMap.set(key, amount);
        }
      })
    })
    let match = true;
    preferentialMap.forEach((value, key) => {
      let amount = amountMap.get(key);
      if (amount >= value) {
        return;
      }
      match = false;
    })

    if (!match) {
      // 表示不满足金额要求
      return 0;
    }
  }

  // 先计算全部优惠券叠加后满足金额不能超过商品的金额
  if (true) {
    let amount = 0;
    couponList.forEach(c => {
      if (c.wechatCoupon.couponType == 7) {
        return;
      }
      if (!c.wechatCoupon.preferentialCondition) {
        // 不限金额
        return;
      }
      amount = amount + c.wechatCoupon.preferentialCondition;
    })
    amount = Number(amount.toFixed(2));
    if (amount > orderAmount) {
      return 0;
    }
  }

  // 单品
  couponList.forEach(c => {
    if (!c.enable) {
      //过滤 不可用的
    }
    if (c.wechatCoupon.couponType == 3 || c.wechatCoupon.couponType == 6) {
      let discountAmount = c.discountAmount;
      goodsList.forEach(g => {
        if (g.commodityId && g.commodityId == c.wechatCoupon.productId) {
          discountAmount = assignGoodsCoupon(discountAmount, g, c);
        }
      })
      c._discountAmount = Number((c.discountAmount - discountAmount).toFixed(2));
    }
  })
  // 计算品类
  couponList.forEach(c => {
    if (!c.enable) {
      //过滤 不可用的
    }
    if (!c.wechatCoupon.categoryIds) {
      return;
    }
    if (c.wechatCoupon.couponType == 2 || c.wechatCoupon.couponType == 5) {
      let discountAmount = c.discountAmount;
      let categoryIds = c.wechatCoupon.categoryIds.split(",");
      let set = new Set(categoryIds);
      goodsList.forEach(g => {
        if (g.bigCategoryId && set.has(g.bigCategoryId + '')) {
          discountAmount = assignGoodsCoupon(discountAmount, g, c);
        }
      })
      c._discountAmount = Number((c.discountAmount - discountAmount).toFixed(2));
    }
  })
  // 计算全部商品
  couponList.forEach(c => {
    if (!c.enable) {
      //过滤 不可用的
    }
    if (c.wechatCoupon.couponType == 1 || c.wechatCoupon.couponType == 4) {
      let discountAmount = c.discountAmount;
      goodsList.forEach(g => {
        discountAmount = assignGoodsCoupon(discountAmount, g, c);
      })
      c._discountAmount = Number((c.discountAmount - discountAmount).toFixed(2));
    }
  })

  // 计算礼品卡
  couponList.forEach(c => {
    if (!c.enable) {
      //过滤 不可用的
    }
    if (c.wechatCoupon.couponType == 8) {
      let discountAmount = c.discountAmount;
      goodsList.forEach(g => {
        discountAmount = assignGoodsCoupon(discountAmount, g, c);
      })
      c._discountAmount = Number((c.discountAmount - discountAmount).toFixed(2));
    }
    if (!c._discountAmount) {
      c.selected = false;
      c._discountAmount = c.discountAmount;
    }
  })

  let totalAmount = 0;
  goodsList.forEach(g => {
    totalAmount = totalAmount + g._coupon; // 优惠金额
  })
  return Number(totalAmount.toFixed(2));
}

/**
 *
 * @param list
 * @param goodsList 商品
 * @param orderAmount 已经减去满减优惠后的金额
 * @param fullPromotionAmount 满减优惠金额
 * @returns {number}
 */
export function initCouponSelected(list, goodsList, orderAmount, fullPromotionAmount) {
  let maxAmount = 0;
  let selectList = [];
  let tempList = [];
  let gitfCouponList = [];
  list.forEach(c => {
    c.selected = false;
    if (!c.enable) {
      return;
    }
    if (c.wechatCoupon.couponType == 3 || c.wechatCoupon.couponType == 6) {
      tempList.push(c);
    }
    if (c.wechatCoupon.couponType == 2 || c.wechatCoupon.couponType == 5) {
      tempList.push(c);
    }
    if (c.wechatCoupon.couponType == 1 || c.wechatCoupon.couponType == 4) {
      tempList.push(c);
    }
    if (c.wechatCoupon.couponType == 8) {
      c.discountAmount = c.balanceAmount;
      gitfCouponList.push(c);
    }
  })

  // TODO兑换券

  // 先单品
  tempList.forEach(c => {
    if (!c.enable) {
      return;
    }
    let ids = [c];
    let discountAmount = c.discountAmount;
    c._discountAmount = c.discountAmount;
    let superposition = c.wechatCoupon.superposition || 1;
    superposition = superposition - 1;
    let superpositionMap = new Map();
    superpositionMap.set(c.wechatCoupon.id, superposition);
    tempList.forEach(next => {
      if (!next.enable) {
        return;
      }
      if (next == c) {
        return;
      }
      if (c.wechatCoupon.id == next.wechatCoupon.id) {
        // 相同的券  计算叠加数量
        if (superposition > 0) {
          ids.push(next);
          let totalAmount = sumCoupon(ids, goodsList, orderAmount, fullPromotionAmount);
          if (totalAmount > discountAmount) {
            // 可以叠加
            discountAmount = totalAmount;
            superposition = superposition - 1;
            superpositionMap.set(c.wechatCoupon.id, superposition);
          } else {
            ids.pop()
          }
        }
        return;
      }
      // 不同的券
      if (!c.wechatCoupon.isCommon || !next.wechatCoupon.isCommon) {
        //不同的券  互斥 不能叠加
        return;
      }
      // 不同的券 判断数量是否可以叠加
      superposition = superpositionMap.get(next.wechatCoupon.id);
      if (superposition == null) {
        superposition = next.wechatCoupon.superposition || 1;
      }
      if (superposition > 0) {
        ids.push(next);
        let totalAmount = sumCoupon(ids, goodsList, orderAmount, fullPromotionAmount);
        if (totalAmount > discountAmount) {
          // 可以叠加
          discountAmount = totalAmount;
          superposition = superposition - 1;
          superpositionMap.set(next.wechatCoupon.id, superposition);
        } else {
          ids.pop()
        }
      }
    })
    if (discountAmount > maxAmount) {
      // 取最优
      selectList = ids;
      maxAmount = discountAmount;
    }
  })

  selectList.forEach(c => {
    c.selected = true;
  })

  maxAmount = sumCoupon(selectList, goodsList, orderAmount, fullPromotionAmount);

  return maxAmount;
}

export function hideText(value, isHide) {
  if (isHide) {
    return "***";
  }
  return value;
}

export function isHideClientIdNumber() {
  try {
    let store = window.sessionStorage.getItem("store");
    if (store) {
      store = JSON.parse(store);
    }
    return store.loginInfo.user.identity != 1;
  } catch (e) {
  }

  return true;
}

export function validateIdNumber(idNumber) {
  if (!(/^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(idNumber))) {
    return false;
  }
  return true;
}

export function hideMessage(value, isHide) {
  if (!isHide) {
    return value;
  }
  if (!value) {
    return;
  }
  let hideStr = "*************************************************";
  if (validateIdNumber(value)) {
    let length = value.length - 1;
    return value.substring(0, 4) + hideStr.substr(0, length) + value.substring(value.length - 1);
  }
  if (value.length > 8) {
    let length = value.length - 8;
    if (length > hideStr.length) {
      length = 4;
    }
    return value.substring(0, 4) + hideStr.substr(0, length) + value.substring(value.length - 4);
  }
  if (value.length >= 6) {
    let length = value.length - 4;
    if (length > hideStr.length) {
      length = 4;
    }
    return value.substring(0, 2) + hideStr.substr(0, length) + value.substring(value.length - 2);
  }
  if (value.length >= 3) {
    let length = value.length - 2;
    if (length > hideStr.length) {
      length = 4;
    }
    return value.substring(0, 1) + hideStr.substr(0, length) + value.substring(value.length - 1);
  }
  if (value.length == 2) {
    return value.substring(0, 1) + "*";
  }
  return "*";
}

export function findAuthorityLabel(key, tree, parentLabel) {
  parentLabel = parentLabel || '';
  if (tree) {
    for (let j = 0, len = tree.length; j < len; j++) {
      let node = tree[j];
      if (node.key == key) {
        let label = node.label.replace(/　/g, "");
        parentLabel = parentLabel.replace(/　/g, "");
        if (parentLabel == "POS权限") {
          parentLabel = "";
        }
        return parentLabel + "-" + label;
      }
      if (node.children) {
        let label = findAuthorityLabel(key, node.children, node.label);
        if (label) {
          return label;
        }
      }
    }
  }
  return "";
}

export function showPrintReportTable(_this, tableDataKey, columns, columnKey, title, amount, callback, eAaPrint) {
  tableDataKey = tableDataKey || 'tableDatatow';
  if (callback == null) {
    callback = () => {
      // 清空数据
      _this.printReportTable = {};
      _this[tableDataKey] = [];
    }
  }

  columns = columns || _this.$refs.tableRef.columns;
  title = title || (_this.templateInfo ? _this.templateInfo.name : "");
  columnKey = columnKey || (_this.templateInfo ? _this.templateInfo.template + "_" + (_this.templateInfo.id || '') : "");
  if (!columnKey) {
    // console.error("打印异常：columnKey为空");
    callback();
    return;
  }
  _this.printReportTable = {
    show: true,
    columns: columns,
    tableData: _this[tableDataKey],
    columnKey: columnKey,
    title: title,
    amount: _this.amount || amount,
    callback: callback,
    templateId: _this.templateInfo.id
  }
  if (eAaPrint) _this.printReportTable.eAaPrint = true;
}

export function isPriceKey(key) {
  let keySet = new Set(
    'shouldMoney,realityMoney,smallChange,paySum,cash,weChat,alipay,sum'
      .split(","));
  if (key) {
    return key.toLowerCase().endsWith('price')
      || key.toLowerCase().endsWith('amount')
      || keySet.has(key);
  }
}

export function formatPrice(num) {
  if (isNaN(num)) {
    return num;
  }
  return Number(num).toFixed(2);
}

export function saveColumnList(columnKey, columnList) {
  if (!columnKey) {
    // console.log("saveColumnList error, columnKey is null")
    return;
  }
  let parentKey = "columnConfig" + getVersionType();
  if (columnList) {
    columnList.forEach(c => {
      if (c.children) {
        let show = false;
        c.children.forEach(ii => {
          show = show || ii.show;
        })
        c.show = show;
      }
    })
  }
  let data = window.localStorage.getItem(parentKey);
  if (data) {
    data = JSON.parse(data);
  } else {
    data = {};
  }
  let saveCollumnList = columnList.map(c => {
    // 只保留必要的字段
    let data = {
      align: c.align, // 默认 left
      char: c.char,
      prop: c.prop,
      show: c.show,
      fontSize: c.fontSize || '',
      title: c.title != c.label ? c.title : ''
    }
    if (!data.title) {
      delete data.title;
    }
    if (!data.char) {
      delete data.char;
    }
    if (!data.align || data.align == 'left') {
      delete data.align;
    }
    if (!data.fontSize) {
      delete data.fontSize;
    }
    return data;
  });
  data[columnKey] = saveCollumnList;
  window.localStorage.setItem(parentKey, JSON.stringify(data));
}

export function getColumnConfig() {
  let parentKey = "columnConfig" + getVersionType();
  let data = window.localStorage.getItem(parentKey);
  if (data) {
    data = JSON.parse(data);
  }
  return data;
}

/**
 *
 * @param _this
 * @param columnkey
 * @param columnList  新增加的列 如果要指定位置 设置defaultIndexKey等于旧的列的prop, 则新列就跟在这旧的列的后面
 * @param noSort
 * @returns {*}
 */
export function initColumnList(_this, columnkey, columnList, noSort) {
  let parentKey = "columnConfig" + getVersionType();
  let data = window.localStorage.getItem(parentKey);
  let config = [];
  try {
    if (data) {
      data = JSON.parse(data);
      config = data[columnkey];
      data = null;
    }
    if (config == null) {
      let key = "columnConfig_" + columnkey;
      let configStr = window.localStorage.getItem(key);
      if (configStr) {
        config = JSON.parse(configStr);
        saveColumnList(columnkey, config);
        window.localStorage.removeItem(key);
      }
    }
  } catch (e) {
  }
  let hideSet = new Set();
  let charMap = new Map();
  let titleMap = new Map();
  columnList.forEach(c => {
    if (c.char) {
      charMap.set(c.prop, c.char);
    }
    if (c.children) {
      c.children.forEach(cc => {
        if (cc.char) {
          charMap.set(cc.prop, cc.char);
        }
      })
    }
  })
  hideSet.add("_all");
  if (Array.isArray(config) && config.length > 0) {
    config.forEach(c => {
      if (!c.show) {
        hideSet.add(c.prop);
      }
      if (c.title) {
        titleMap.set(c.prop, c.title);
      }
      let initChar = charMap.get(c.prop) || 0;
      charMap.set(c.prop, c.char || initChar);
      if (c.children) {
        c.children.forEach(cc => {
          if (!cc.show) {
            hideSet.add(cc.prop);
          }
          if (cc.title) {
            titleMap.set(cc.prop, cc.title);
          }
          initChar = charMap.get(cc.prop) || 0;
          charMap.set(cc.prop, cc.char || initChar);
        })
      }
    })
  } else {
    columnList.forEach(f => {
      if (f.defaultShow != null && f.defaultShow == false) {
        hideSet.add(f.prop);
      }
    })
  }
  // hide 是程序控制 如果为true .，而且用户也不可以编辑
  columnList.forEach((f, index) => {
    if (f.children) {
      let show = false;
      f.children.forEach((ii) => {
        let iiShow = ((!ii.hide) && !hideSet.has(ii.prop));
        show = show || iiShow;
        _this.$set(ii, 'show', iiShow);
        ii.char = charMap.get(ii.prop) || '';
        _this.$set(ii, 'width', getTextWidth(ii.char, ii.fontSize || 14) || ii.minWidth);
        // eval("ii.show"+'='+ iiShow);
        let title = titleMap.get(ii.prop);
        if (title) {
          _this.$set(ii, 'title', title);
        }
      });
      _this.$set(f, 'show', show);
      // eval("f.show"+'='+ show);
      return;
    }
    f.char = charMap.get(f.prop) || '';
    _this.$set(f, 'width', getTextWidth(f.char, f.fontSize || 14) || f.minWidth);
    _this.$set(f, 'show', (!f.hide) && !hideSet.has(f.prop));
    let title = titleMap.get(f.prop);
    if (title) {
      _this.$set(f, 'title', title);
    }
    // eval("f.show"+'='+((!f.hide)&& !hideSet.has(f.prop)));
  })
  // 排序
  if (config && (!noSort)) {
    let sortMap = new Map();
    config.forEach((c, index) => {
      sortMap.set(c.prop, index);
    });
    columnList.forEach((c, index) => {
      let t = sortMap.get(c.prop);
      if (t == null && c.defaultIndexKey) {
        t = sortMap.get(c.defaultIndexKey);
      }
      c.__sortIndex = t == null ? index : t;
    });
    columnList.sort((a, b) => {
      return a.__sortIndex - b.__sortIndex;
    })
    columnList.forEach(c => {
      delete c.__sortIndex;
    })
  }
  // console.log(columnList);
  return columnList;
}

export function saveQuickList(quickList) {
  quickList = quickList.map((item) => {
    return {
      prop: item.prop,
      show: item.show
    }
  });
  quickList.forEach((item, index) => {
    item.index = index + 1;
  })
  let key = 'quickList' + getVersionType();
  window.localStorage.setItem(key, JSON.stringify(quickList));
}

export function commodityUpdateFlag() {
  window.localStorage.setItem("commodityUpdateFlag", "1");
}

export function getQuickList() {
  let quickList = [{label: isHD() ? '零售开单' : '顾客开单', img: 'recording2', show: true, ids: '11_101'},
    {label: '账单详情', img: 'salesmx', show: true, ids: '11_247'},
    {label: '销售明细', img: 'shohuod', show: false, ids: '11_241'},
    {label: '支付明细', img: 'receivePayment', show: false, ids: '11_245'},
    {label: '商品档案', img: 'commodity', show: true, ids: '3_5',}, // 3 表示 当前home nav的id, 5 是对应的id
    {label: '新增商品', img: 'recording3', show: true, ids: '3_5', optType: 1,}, // 3 表示 当前home nav的id, 5 是对应的id
    {label: '门店配置', img: 'merchant', show: false, ids: '3_14',},
    {label: '会员档案', img: 'member', show: true, ids: '9_103'},
    {label: '新增会员', img: 'memberOpt', show: true, ids: '9_103', optType: 1,},
    {label: '供应商档案', img: 'supplier', show: false, ids: '3_7'},
    {label: '客户档案', img: 'client', show: false, ids: '3_10'},
    {label: '库存查询', img: 'warehouse', show: true, ids: '7_1'},
    {label: isHD() ? '进销存流水表' : '进销存变动表', img: 'saveda', show: false, ids: '7_341'},
  ];
  quickList.forEach(item => {
    item.prop = item.ids + "__" + (item.optType || '');
    item.width = 40;
    item.index = 9999;
  });
  let key = 'quickList' + getVersionType();
  let data = window.localStorage.getItem(key);
  if (data) {
    try {
      let indexMap = new Map();
      let showSet = new Set();
      data = JSON.parse(data);
      data.forEach((d, index) => {
        indexMap.set(d.prop, d.index);
        if (d.show == true) {
          showSet.add(d.prop)
        }
      })
      quickList.forEach(q => {
        q.show = showSet.has(q.prop);
        let i = indexMap.get(q.prop);
        q.index = i || q.index;
      });
      quickList.sort(function (a, b) {

        return a.index - b.index;
      });
    } catch (e) {
//    console.log(e);
    }
  }
  return quickList;
}

export function checkAuthority(_this, key, showError) {
  let identity = _this.$store.state.loginInfo.user.identity;
  let authority = _this.$store.state.loginInfo.user.authority || {};
  let result = (identity != 1 && authority[key] > 0) ? false : true;
  if (!result && showError) {
    let keyLabel = findAuthorityLabel(key, authorityData());
    _this.$alert("没有" + keyLabel + "权限");
  }
  return result;
}

export function hideData(_this, order, details) {
  if (details) {
    details.forEach(item => {
      item.price = hideText(item.price, _this.hidePrice);
      item.effectiveAmount = hideText(item.effectiveAmount, _this.hidePrice);
      item.totalAmount = hideText(item.totalAmount, _this.hidePrice);
      item.costPrice = hideText(item.costPrice, _this.hideCostPrice);
      item.costAmount = hideText(item.costAmount, _this.hideCostPrice);
      item.diffCostAmount = hideText(item.diffCostAmount, _this.hideCostPrice);
      item.newCostPrice = hideText(item.newCostPrice, _this.hideCostPrice);
      item.diffCostPrice = hideText(item.diffCostPrice, _this.hideCostPrice);
      item.differenceAmount = hideText(item.differenceAmount, _this.hidePrice);
      item.diffSalesAmount = hideText(item.diffSalesAmount, _this.hidePrice);
      item.giveAmount = hideText(item.giveAmount, _this.hideCostPrice);
      item.stockAmount = hideText(item.stockAmount, _this.hideCostPrice);
      item.totalstockAmount = hideText(item.totalstockAmount, _this.hideCostPrice);
      item.avgCostPrice = hideText(item.avgCostPrice, _this.hideCostPrice);
      item.wholesalePrice = hideText(item.wholesalePrice, _this.hideWholesalePrice);
      item.wholesalePrice2 = hideText(item.wholesalePrice2, _this.hideWholesalePrice);
      item.wholesalePrice3 = hideText(item.wholesalePrice3, _this.hideWholesalePrice);
      item.wholesalePrice4 = hideText(item.wholesalePrice4, _this.hideWholesalePrice);
      item.purchasePrice = hideText(item.purchasePrice, _this.hidePurchasePrcie);
      if (item.details) {
        item.details.forEach(dd => {
          dd.price = hideText(dd.price, _this.hidePrice);
          dd.totalAmount = hideText(dd.price, _this.hidePrice);
          dd.effectiveAmount = hideText(dd.effectiveAmount, _this.hidePrice);
          dd.giveAmount = hideText(dd.giveAmount, _this.hidePrice);
          dd.differenceAmount = hideText(dd.differenceAmount, _this.hidePrice);
          dd.diffCostAmount = hideText(dd.diffCostAmount, _this.hideCostPrice);
          dd.costPrice = hideText(dd.costPrice, _this.hideCostPrice);
          dd.costAmount = hideText(dd.costAmount, _this.hideCostPrice);
          dd.newCostPrice = hideText(dd.newCostPrice, _this.hideCostPrice);
          dd.diffCostPrice = hideText(dd.diffCostPrice, _this.hideCostPrice);
          dd.diffSalesAmount = hideText(dd.diffSalesAmount, _this.hidePrice);
          dd.stockAmount = hideText(dd.stockAmount, _this.hideCostPrice);
          dd.purchasePrice = hideText(dd.purchasePrice, _this.hidePurchasePrcie);
          dd.wholesalePrice = hideText(dd.wholesalePrice, _this.hideWholesalePrice);
          dd.wholesalePrice2 = hideText(dd.wholesalePrice2, _this.hideWholesalePrice);
          dd.wholesalePrice3 = hideText(dd.wholesalePrice3, _this.hideWholesalePrice);
          dd.wholesalePrice4 = hideText(dd.wholesalePrice4, _this.hideWholesalePrice);
          dd.totalStockAmount = hideText(dd.totalStockAmount, _this.hideCostPrice);
          dd.avgCostPrice = hideText(dd.avgCostPrice, _this.hideCostPrice);

        })
      }
    })
  }
  if (order) {
    order['giveAmount'] = hideText(order['giveAmount'], _this.hidePrice);
    order['diffSalesAmount'] = hideText(order['diffSalesAmount'], _this.hidePrice);
    order['effectiveAmount'] = hideText(order['effectiveAmount'], _this.hidePrice);
    order['totalAmount'] = hideText(order['totalAmount'], _this.hidePrice);
    order['differenceAmount'] = hideText(order['differenceAmount'], _this.hidePrice);
    order['costAmount'] = hideText(order['costAmount'], _this.hideCostPrice);
    order['diffCostAmount'] = hideText(order['diffCostAmount'], _this.hideCostPrice);
    order['stockAmount'] = hideText(order['stockAmount'], _this.hideCostPrice);
    order['totalStockAmount'] = hideText(order['totalStockAmount'], _this.hideCostPrice);
  }

}

export function getVersionType() {
  let versionType = window.localStorage.getItem("versionType");
  if (versionType) {
    return versionType;
  }
  return 35; // 眼镜版
}

export function formatCode(value, len) {
  if (value > 0) {
    value = value + '';
    while (value.length < len) {
      value = '0' + value;
    }
    return value;
  }
  return '000';
}

export function isFace() {
  return isHD();
}

// 是否为服装版
export function isClothing() {
  let version = window.localStorage.getItem('versionType');
  return '36' == version;
}

// 是否为器械版本
export function isApparatus () {
  let version = getVersionType();
  return '38' == version;
}

// 是否为医药版本
export function isMedicine () {
  let version = getVersionType();
  return '37' == version;
}

export function getCodeTitle(title) {
  if (isClothing()) {
    return '款号';
  }
  return title
}

export function getColorTitle(title) {
  if (isClothing()) {
    return '颜色';
  }
  return title
}

export function getDiopterTitle(title) {
  if (isClothing()) {
    return '尺码';
  }
  return title
}

export function setParamInfo(key, value) {
  try {
    let paramInfo = window.localStorage.getItem('paramInfo');
    paramInfo = paramInfo ? JSON.parse(paramInfo) : {};
    paramInfo[key] = value;
    window.localStorage.setItem("paramInfo", JSON.stringify(paramInfo));
  } catch (e) {

  }
}

export function getParamInfo(key, defalultValue) {
  let value = defalultValue;
  try {
    let paramInfo = window.localStorage.getItem('paramInfo');
    paramInfo = paramInfo ? JSON.parse(paramInfo) : {};
    value = paramInfo[key];
    return value == undefined ? defalultValue : value;
  } catch (e) {
  }
  return value;
}

export function saveTableType(tableType, key) {
  key = key || "tableType"
  window.localStorage.setItem(key + getVersionType(), tableType);
}

export function getTableType(key) {
  let defaultTableType = 3;
  if (isClothing()) {
    defaultTableType = 2;
  }
  try {
    let versionType = getVersionType();
    key = key || "tableType"
    let tableType = parseInt(window.localStorage.getItem(key + versionType));
    if (versionType != 36 && tableType == 2) {
      tableType = 3;
      return tableType;
    }
    return isNaN(tableType) ? defaultTableType : tableType;
  } catch (e) {
  }
  return defaultTableType;
}


export function getGlassesFlag() {
  // 是否有眼镜标记
  let versionType = getVersionType();
  if (!versionType && window.location.host.indexOf('eye.') != -1) {
    return true;
  }
  if (versionType == 35) {
    return true;
  }
  let merchantId = window.sessionStorage.getItem("merchantId");
  merchantId = merchantId || '';
  let glassesFlag = window.localStorage.getItem("glassesFlag" + merchantId);
  return glassesFlag == 1 ? true : false;
}

/**
 * 有颜色度数尺码
 * @returns {boolean}
 */
export function isColorAndDiopter() {
  // 是否有眼镜标记
  if (getVersionType() == 35) {
    return true;
  }
  if (isClothing()) {
    return true;
  }
  let merchantId = window.sessionStorage.getItem("merchantId");
  merchantId = merchantId || '';
  let glassesFlag = window.localStorage.getItem("glassesFlag" + merchantId);
  return glassesFlag == 1 ? true : false;
}

export function saveGlassesFlag(glassesFlag) {
  // 是否有眼镜标记
  if (getVersionType() == 35) {
    return;
  }
  let merchantId = window.sessionStorage.getItem("merchantId");
  merchantId = merchantId || '';
  glassesFlag = glassesFlag ? 1 : 0;
  window.localStorage.setItem("glassesFlag" + merchantId, glassesFlag);
  return glassesFlag == 1 ? true : false;
}

/**
 * 海德的
 * @returns {boolean}
 */
export function isHD() {
  return window.localStorage.getItem("isHD") == 'true' ? true : false;
}

function getDiopterKey(d) {
  return "diopter_" + getDiopter_label(d);
}

function getDiopter_label(d) {
  return (d.diopterName || d.astigmaticDiopterName || "均码");
}

/**
 * 汇总展示
 * @param _this
 * @param params {totalCountKey,  // 数量prop
 *              tableData,  // 数据
 *               amount,  // 合计
 *               showKeys, // 需要显示的prop 逗号分隔
 *               columnList // 表头配置
 *               }
 * @returns  columnList 新的列标题
 */
export function initTableType3(_this, params) {
  params = params || {};
  let showKeys = new Set((params.showKeys || "").split(","))
  let columnList = (params.columnList || _this.columnList);
  let hideSet = getHideSet();
  columnList.forEach((c, index) => {
    if (hideSet.has(c.prop)) {
      _this.$set(c, 'hide', true);
    }
    if (c.prop == 'colorName') {
      _this.$set(c, 'show', false);
    }
    if (c.prop == 'totalCount') {
      _this.$set(c, 'show', true);
    }
    if (c.prop == 'diopterName') {
      _this.$set(c, 'show', false);
    }
    if (showKeys.has(c.prop)) {
      _this.$set(c, 'hide', false);
    }
  });
  _this.$forceUpdate();
  return columnList;
}

/**
 *
 * @param _this
 * @param params {totalCountKey,  // 数量prop
 *              tableData,  // 数据
 *               amount,  // 合计
 *               showKeys, // 需要显示的prop 逗号分隔
 *               columnList // 表头配置
 *               tableTypeKey, // tableType 的key
 *               }
 * @returns  columnList 新的列标题
 */
export function initTableType(_this, params) {
  params = params || {};
  let tableTypeKey = params.tableTypeKey || 'tableType';
  let tableType = _this[tableTypeKey];
  if (tableType == 1) {
    return initTableType1(_this, params);
  }
  if (tableType == 3) {
    return initTableType3(_this, params);
  }
  return initTableType2(_this, params);
}

function getHideSet() {
  let hideSet = new Set(("batchNumber,produceDate,expireDate,validDate").split(","));
  if (isClothing()) {
    hideSet.add('stockBarcode');
    hideSet.add('stockCode');
  }
  if (isGlasses()) {
    hideSet.add('stockIndex');
  }
  return hideSet;
}

export function initTableType1(_this, params) {
  params = params || {};
  let columnList = (params.columnList || _this.columnList);
  let hideSet = getHideSet();
  hideSet.add("remainCount");
  // hideSet.add("diopterName");
  columnList.forEach((c, index) => {
    if (hideSet.has(c.prop)) {
      _this.$set(c, 'hide', false);
    }
    if (c.prop == 'colorName') {
      _this.$set(c, 'show', true);
    }
    if (c.prop == 'diopterName') {
      _this.$set(c, 'show', true);
    }
  });
  _this.$forceUpdate();
  return columnList;
}

/**
 *
 * @param _this
 * @param params {totalCountKey,  // 数量prop
 *              tableData,  // 数据
 *               amount,  // 合计
 *               showKeys, // 需要显示的prop 逗号分隔
 *               columnList // 表头配置
 *               }
 * @returns  columnList 新的列标题
 */
export function initTableType2(_this, params) {
  params = params || {};
  let params3 = JSON.parse(JSON.stringify(params));
  let params3ShowKeys = params3.showKeys || "";
  params3ShowKeys = "stockBarcode,stockCode," + params3ShowKeys;
  params3.showKeys = params3ShowKeys;
  let columnList = initTableType3(_this, params3);
  columnList = columnList.filter(c => !c.prop || !c.prop.startsWith("diopter_"));

  let defaultDioperName = "均码";
  let totalCountKey = params.totalCountKey || 'totalCount';
  let tableData = params.tableData || _this.tableData;
  let totalAmountKey = params.totalAmountKey || 'totalAmount';
  let amount = params.amount || _this.amount;
  let showKeys = new Set((params.showKeys || "").split(","))
  let groupMap = new Map();
  let diopterNameSet = new Set();
  let sumAmount = true;
  if (amount && amount.details) {
    sumAmount = false;
    amount.details.forEach(d => {
      diopterNameSet.add(d.diopterName ? d.diopterName : defaultDioperName);
      diopterNameSet.add(d.astigmaticDiopterName ? d.astigmaticDiopterName : defaultDioperName);
      amount[getDiopterKey(d)] = d[totalCountKey] || 0;
    });
  }
  tableData.forEach(item => {
    let d = item;
    delete d._XID;
    if (d.details && d.details.length > 0) {
      d.details.forEach(dd => {
        delete dd._XID;
        diopterNameSet.add(dd.diopterName ? dd.diopterName : defaultDioperName);
        diopterNameSet.add(dd.astigmaticDiopterName ? dd.astigmaticDiopterName : defaultDioperName);
      })
    }
  });
  diopterNameSet.add(defaultDioperName);
  // let diopterNames = Array.from(diopterNameSet);// 尺码
  let diopterNames = [];
  diopterNames = diopterNames.sort((d1, d2) => {
    if (d1 == 0) {
      return 1;
    }
    if (d2 == 0) {
      return -1;
    }
    return d1.toLowerCase() < d2.toLowerCase() ? -1 : 1;
  });
  groupMap.clear();
  // 构建title
  // 找到颜色的名称
  let colorNameIndex = 0;
  let hideSet = new Set(("astigmaticDiopterName,stockCode,stockBarcode,prismDiopterName,count,qty").split(","));
  let width = 0;
  let minWidth = 100;
  let countShow = true;
  let countWidth = 100;
  columnList.forEach((c, index) => {
    if (c.prop == 'colorName') {
      colorNameIndex = index;
      _this.$set(c, 'show', true);
    }
    if (c.prop == 'diopterName') {
      _this.$set(c, 'show', false);
      width = c.width;
      minWidth = c.minWidth || 100;
    }
    if (c.prop == 'effectiveCount') {
      countShow = c.show;
      countWidth = c.width;
    }
    if (hideSet.has(c.prop)) {
      _this.$set(c, 'hide', true);
    }
    if (c.prop.endsWith('Count')) {
      _this.$set(c, 'show', false);
    }
    if (c.prop != 'price' && c.prop.endsWith('Price')) {
      _this.$set(c, 'show', false);
    }
    if (c.prop != 'totalAmount' && c.prop.endsWith('Amount')) {
      _this.$set(c, 'show', false);
    }
    if (showKeys.has(c.prop)) {
      _this.$set(c, 'show', true);
    }
  });
  if (!(colorNameIndex > 0)) {
    colorNameIndex = columnList.length - 1;
  }
  let newColumNampes = diopterNames.filter(d => d && d != defaultDioperName).map(d => {
    return {prop: 'diopter_' + d, label: d, minWidth: minWidth, width: width, show: true, type: 'text'};
  });
  /* newColumNampes.push({
    prop: 'diopter_' + defaultDioperName,
    label: defaultDioperName,
    minWidth: minWidth,
    width: width,
    show: true,
    type: 'text'
  }); */
  newColumNampes.push({
    prop: 'diopterName',
    label: '尺码',
    minWidth: minWidth,
    width: width,
    show: true,
    type: 'text'
  });

  newColumNampes.push({
    prop: totalCountKey, label: '数量',
    minWidth: minWidth,
    width: countWidth < 100 ? 100 : countWidth, show: countShow, type: 'text'
  });
  columnList.splice(colorNameIndex + 1, 0, ...newColumNampes);

  // 构建二维数据
  if (sumAmount) {
    diopterNames.forEach(key => {
      key = key ? key : defaultDioperName;
      amount['diopter_' + key] = 0;
    });
    amount[totalCountKey] = 0;
  }

  tableData.forEach(item => {
    let diopterMap = new Map();
    if (item.details) {
      item.details.forEach(dd => {
        let key = dd.diopterName || dd.astigmaticDiopterName;
        key = key ? key : defaultDioperName;
        diopterMap.set(key, dd);
      });
      item[totalCountKey] = 0;
      item[totalAmountKey] = 0;
    }
    diopterNames.forEach(key => {
      key = key ? key : defaultDioperName;
      let diopter = diopterMap.get(key);
      let prop = 'diopter_' + key;
      item[prop] = diopter && !isNaN(diopter[totalCountKey]) ? diopter[totalCountKey] : 0;
      item[totalCountKey] = item[totalCountKey] + item[prop];
      item[totalAmountKey] = item[totalAmountKey] + (diopter && !isNaN(diopter[totalAmountKey]) ? diopter[totalAmountKey] : 0);
      item[totalCountKey] = Number(item[totalCountKey].toFixed(4))
      item[totalAmountKey] = Number(item[totalAmountKey].toFixed(4))
      if (!item.details && key == defaultDioperName) {
        item[prop] = item[totalCountKey];
      }
      if (sumAmount) {
        amount[prop] = amount[prop] + item[prop];
      }
    })
    if (!item.details) {
      item['diopter_' + defaultDioperName] = item[totalCountKey];
    }
    item[totalAmountKey] = Number(formatPrice(item[totalAmountKey]));
    if (item[totalCountKey] != 0) {
      item.price = Number(formatPrice(Number(item[totalAmountKey]) / item[totalCountKey]));
    }

    if (item[totalCountKey] == 0 && item.details && item.details.length > 0) {
      if (_this.templateInfo.id == 1) {
        item[totalCountKey] = item.details.map(i => Number(i.remainCount || 0)).reduce(((a, b) => a + b), 0);
      } else {
        if (_this.templateInfo.template == "OrderForm") {
          item[totalCountKey] = item.details.map(i => Number(i.totalCount || 0)).reduce(((a, b) => a + b), 0);
        } else {
          item[totalCountKey] = item.details.map(i => Number(i[item.qtyType == 0 ? 'qty' : 'refundQty'] || 0)).reduce(((a, b) => a + b), 0);
        }
      }
    }
    if (item[totalAmountKey] == 0 && item.details && item.details.length > 0) {
      item[totalAmountKey] = item.details.map(i => Number(i.totalAmount || 0)).reduce(((a, b) => a + b), 0).toFixed(2);

      if (item[totalAmountKey] == 0) {
        item[totalAmountKey] = item.details.map(i => Number(i.amount || 0)).reduce(((a, b) => a + b), 0).toFixed(2);
      }
    }

    if (sumAmount) {
      amount[totalCountKey] = (amount[totalCountKey] > 0 ? amount[totalCountKey] : 0) + item[totalCountKey];
      amount[totalCountKey] = Number(amount[totalCountKey].toFixed(4));
    }
  });

  _this.$forceUpdate();
  return columnList;
}

export function getUDIConfig() {
  let udiConfigStr = window.sessionStorage.getItem("udiConfig");
  if (udiConfigStr) {
    return JSON.parse(udiConfigStr);
  }
  return null;
}

export function trimAll(str) {
  if (!str) {
    return str;
  }
  return str.replace(/\s/g, "")
}

export function isCouponDisable(_this) {
  return false;
  // let merchantId = _this.$store.state.merchantId || 0;
  // switch (merchantId) {
  //   case 223:
  //     return false;
  // }
  // return true;
}
export function getParseUDI(udi, _this) {
  let obj = {};
  return _this.$http.get(interfaceFn() + '/commodity/parseGoodsUdi?udi=' + udi).then((res) => {
  // return _this.$http.get(interfaceFn() + '/commodity/parseAndSearchUdi?udi=' + udi).then((res) => {
    if (res.data.code == 0) {
      let data = res.data.data;
      // let udiParse = data.udiParse;
      data.map(i => {
        if (i.key == 'guid') {
          obj.guid = i.value;
        }
        if (i.key == 'produceDate') {
          obj.produceDate = i.value;
        }
        if (i.key == 'expireDate') {
          obj.expireDate = i.value;
        }
        if (i.key == 'batchNumber') {
          obj.batchNumber = i.value;
        }
        if (i.key == 'stockIndex') {
          obj.stockIndex = i.value;
        }
      })
      return obj;
    }
  })
}

// 不按顺序解释
export function parseUDI(udi, configList, symbol, _this) {
  if (!symbol) symbol = "(";
  if (!configList) {
    configList = getUDIConfig();
  }
  if (!configList) {
    return null;
  }
  if (!(configList instanceof Array) && configList.udiConfig) {
    configList = JSON.parse(configList.udiConfig);
  }
  configList = configList.filter(c => c.splitChar);
  if (!configList) {
    return null;
  }
  let obj = null;
  configList.forEach((c, index) => {
    if (!udi) {
      return;
    }
    if (c.splitChar) {
      let splitChar = (symbol == "(" ? "(" : "（") + c.splitChar.trim() + (symbol == "(" ? ")" : "）");
      let key = c.key;
      let value = "";
      let index = udi.indexOf(splitChar);
      if (index >= 0) {
        let startIndex = index + splitChar.length;
        value = udi.substring(startIndex);
        let endIndex = value.indexOf(symbol);
        if (endIndex > 0) {
          value = value.substring(0, endIndex);
        }
        if (value) {
          if (key == "guid") {
            value = trimAll(value);
          }
          if (obj == null) {
            obj = {};
          }
          if (key == 'batchNumber') {
            // value = formatUdiDate(value, '');
          }
          if (key == 'expireDate') {
            value = formatUdiDate(value, '-');
          }
          if (key == 'produceDate') {
            value = formatUdiDate(value, '-');
          }
          obj[key] = value;
        }
      }
    }
  })
  return obj;
}

// 按顺序解释
// export function parseUDI(udi, configList) {
//   if (!configList) {
//     configList = getUDIConfig();
//   }
//   if (!configList) {
//     return null;
//   }
//   if(!(configList instanceof  Array) && configList.udiConfig){
//     configList = JSON.parse(configList.udiConfig);
//   }
//   configList = configList.filter(c => c.splitChar);
//   if (!configList) {
//     return null;
//   }
//   let obj = null;
//   configList.forEach((c, index) => {
//     if (!udi) {
//       return;
//     }
//     if (c.splitChar) {
//       let splitChar = "(" + c.splitChar.trim() + ")";
//       let key = c.key;
//       let value = "";
//       if (udi.startsWith(splitChar)) {
//         let nextSplitChar = "";
//         let next = configList[index + 1];
//         let startIndex = udi.indexOf(splitChar) + splitChar.length;
//         if (next) {
//           nextSplitChar = "(" + next.splitChar.trim() + ")";
//           let nextIndex = udi.indexOf(nextSplitChar);
//           if (nextIndex > 0) {
//             value = udi.substring(startIndex, udi.indexOf(nextSplitChar));
//             udi = udi.substring(startIndex + value.length);
//           } else {
//             value = udi.substring(startIndex);
//             udi = "";
//           }
//         } else {
//           value = udi.substring(startIndex);
//           udi = "";
//         }
//         if (value) {
//           if(key == "guid"){
//             value = trimAll(value);
//           }
//           if (obj == null) {
//             obj = {};
//           }
//           if (key == 'batchNumber') {
//             // value = formatUdiDate(value, '');
//           }
//           if (key == 'expireDate') {
//             value = formatUdiDate(value, '-');
//           }
//           if (key == 'produceDate') {
//             value = formatUdiDate(value, '-');
//           }
//           obj[key] = value;
//         }
//       }
//     }
//   })
//   return obj;
// }

export function formatUdiDate(value, split) {
  if (value.length >= 8 && !split) {
    return value;
  }
  if (isNaN(value)) {
    return value;
  }
  value = parseInt(value) + "";
  if (value.length == 6) {
    value = "20" + value;
  }
  if (value.length == 7) {
    value = "2" + value;
  }
  return value.substring(0, 4) + split + value.substring(4, 6) + split + value.substring(6, 8);
}

// 眼镜版
export function isGlasses() {
  let versionType = getVersionType();
  let host = window.location.host;
  if (versionType == 35 || host.indexOf('eye.') != -1) {
    return true;
  }
  return false;
  // return getGlassesFlag();
}

export function isUDI() {
  // return false;
  return isGlasses() || getVersionType() == 37 || getVersionType() == 38;
}

export function hidePhone(val) {
  if (!val) {
    return ''
  }
  val = val + "";
  let xing = "**********";
  if (val.length <= 6) {
    return xing.substr(0, val.length - 1) + val.substr(val.length - 1, val.length);
  }
  if (val.length <= 8) {
    return val.substr(0, 2) + xing.substr(0, 4) + val.substr(6);
  }
  if (val.length <= 11) {
    return val.substr(0, 3) + xing.substr(0, 4) + val.substr(7);
  }
  let length = val.length - 8;
  if (length > 10) {
    length = 10;
  }
  return val.substr(0, 4) + xing.substr(0, length) + val.substr(val.length - 4);
}

export function calculateTpInfoPrintWidth(_this, tpInfo, px) {
  // widthGoodsName: '',
  // widthQty: '',
  // widthAmount: '',
  // widthUnitPrice: '',
  if (!tpInfo) {
    return;
  }
  if (!tpInfo.width) {
    return;
  }
  _this.printWidth = parseInt(Number(tpInfo.width) * px);
  _this.printWidth = _this.printWidth + 5;
}

export function isZmd() {
  // 是否为专卖店版
  if (isClothing()) {
    return true;
  }
  if (isMedicine()) {
    return true;
  }
  if (window.location.hostname.startsWith("zmd.")) {
    return true;
  }
  return false;
}

// 是否有GSP
export function isStockGPS() {
  return isStockGSP();
}

export function isStockGSP() {
  if (isClothing()) {
    return false;
  }
  // 默认是眼镜版
  return true;
}


export function isStockShow(stockType) {
  if (!isStockGPS()) {
    return false;
  }
  let parmaInfo = window.localStorage.getItem('paramInfo');
  if (parmaInfo) {
    parmaInfo = JSON.parse(parmaInfo);
    let key = toHump(stockType);
    if (parmaInfo[key] != null) {
      return parmaInfo[key] + '' == 'true';
    }
  }
  return true;
}

// 是否有首营质量管理
export function isQualityControl() {
  if (isClothing()) {
    return false;
  }
  if (isPC()) {
    return window.localStorage.getItem('pcQualityControlShow') == 'true' ? true : false;
  }
  // 默认是眼镜版
  return true;
}

export function findPrinterIndex(LODOP, printConfig) {
  try {
    var printerList = [];
    if (!printConfig) {
      return 0;
    }
    if (printConfig.printerName) {
      printerList = [];
      let counter = LODOP.GET_PRINTER_COUNT();
      for (let i = 0; i < counter; i++) {
        printerList.push({
          name: LODOP.GET_PRINTER_NAME(i),
          value: i
        })
      }
      if (!printerList) {
        return 0;
      }
      let printer = printerList.find(p => p.name == printConfig.printerName);
      if (printer) {
        return printer.value || 0;
      }
    }
  } catch (e) {
    console.log(e);
  }
  return printConfig.printIndex || 0;
}

export function savePageCount(key, count) {
  key = key || 'count';
  let countConfigStr = window.localStorage.getItem("pageCount");
  let countConfig = {};
  if (countConfigStr) {
    try {
      countConfig = JSON.parse(countConfigStr);
    } catch (e) {
    }
  }
  countConfig[key] = count || 20;
  window.localStorage.setItem('pageCount', JSON.stringify(countConfig));
}

export function getPageCount(key, defaulCount) {
  key = key || 'count';
  let countConfigStr = window.localStorage.getItem("pageCount");
  let countConfig = {};
  if (countConfigStr) {
    try {
      countConfig = JSON.parse(countConfigStr);
    } catch (e) {
    }
  }
  return countConfig[key] || defaulCount || 20;
}

var canvas;

export function getTextWidth(char, fontSzie) {
  if (isNaN(char)) {
    return 0;
  }
  let text = 'A';
  let font = 'normal ' + fontSzie + 'px sans-serif';
  // re-use canvas object for better performance
  canvas = canvas || (document.createElement('canvas'));
  const context = canvas.getContext('2d');
  context.font = font;
  return parseInt(context.measureText(text).width * char);
}

export function authorityData() {
  const authorityTree = [
    {
      label: 'POS权限',
      key: '_POS权限',
      children: [{
        label: '折扣　　',
        key: 'discount',
        input: {label: "折扣下限", tips: "80%为8折", subfix: "%", key: "minDiscount", value: "",},
      }, {
        label: '手动优惠',
        key: 'manualOff',
        input: {label: "手动优惠金额上限", tips: "金额上限", subfix: "元", value: "", key: "maxManualOff",},
      },
        {label: '修改价格', key: 'editPrice',},
        {label: '赠送　　　', key: 'give',},
        {label: '退货　　', key: 'refund',},
        {label: '删单　　', key: 'deleteOrder',},
        {label: '查看进价', key: 'viewPurchasePrice',},
        {label: '查看批发价', key: 'viewWholesalePrice',},
        {label: '查看成本', key: 'viewCostPrice',},
        {label: '查看毛利', key: 'viewProfit',}
      ],
    },
    {
      label: '模块权限',
      children: [
        {label: '零售管理', key: 'moduleSale'},
        {label: isGlasses() ? '验光记录' : '会员操作', key: 'moduleOptometry'},
        {label: '基本资料', key: 'moduleIndex',},
        {label: '质量管理', hide: !isGlasses(), key: 'moduleQuality'},
        {label: '采购管理', key: 'modulePurchase'},
        {label: '销售管理', key: 'moduleWholesale'},
        {label: '库存管理', key: 'moduleStock'},
        {label: '财务相关', key: 'moduleFinance'},
        {label: '会员管理', key: 'moduleMember'},
        {label: '短信管理', key: 'moduleSms'},
        {label: '促销管理', key: 'modulePromotion'},
        {label: '系统设置', key: 'moduleSetting'},
        {label: '公众号　', key: 'moduleWechat'},
        {label: '小程序 ', key: 'moduleApplet'}],
    },
    {
      label: '零售管理',
      children: [{
        label: '促销',
        children: [
          {label: '查看', key: 'viewPromotion',},
          {label: '新增', key: 'addPromotion',},
          {label: '编辑', key: 'editPromotion',},
          {label: '删除', key: 'deletePromotion',},
          {label: '导出', key: 'exportPromotion',},
          {label: '打印', key: 'printPromotion',},
        ],
      }, {
        label: '零售报表',
        children: [
          {label: '查看', key: 'viewOrderReport',},
          {label: '导出', key: 'exportOrderReport',},
          {label: '打印', key: 'printOrderReport',},
        ],
      }, {
        label: '支付报表',
        children: [
          {label: '查看', key: 'viewPaymentReport',},
          {label: '导出', key: 'exportPaymentReport',},
          {label: '打印', key: 'printPaymentReport',},
        ],
      }, {
        label: '交班报表',
        children: [
          {label: '查看', key: 'viewShiftRecordReport',},
          {label: '导出', key: 'exportShiftRecordReport',},
          {label: '打印', key: 'printShiftRecordReport',},
        ],
      }, {
        label: '员工提成报表',
        children: [
          {label: '查看', key: 'viewCommissionReport',},
          {label: '导出', key: 'exportCommissionReport',},
          {label: '打印', key: 'printCommissionReport',},
        ],
      }, {
        label: '成本，利润报表',
        children: [
          {label: '查看', key: 'viewCostReport',},
          {label: '导出', key: 'exportCostReport',},
          {label: '打印', key: 'printCostReport',},
        ],
      }],
    },
    {
      label: '基本资料',
      children: [{
        label: '门店档案',
        children: [
          {label: '查看', key: 'viewShop',},
          {label: '新增', key: 'addShop',},
          {label: '编辑', key: 'editShop',},
          {label: '导出', key: 'exportShop',},
        ],
      }, {
        label: '员工档案',
        children: [
          {label: '查看', key: 'viewUser',},
          {label: '新增', key: 'addUser',},
          {label: '编辑', key: 'editUser',},
          {label: '删除', key: 'deleteUser',},
          {label: '导出', key: 'exportUser',},
        ],
      },
        {
          label: '币种档案',
          children: [
            {label: '查看', key: 'viewMoneyCategory',},
            {label: '新增', key: 'addMoneyCategory',},
            {label: '编辑', key: 'editMoneyCategory',},
            {label: '删除', key: 'deleteMoneyCategory',},
            {label: '导出', key: 'exportMoneyCategory',},
          ],
        }, {
          label: '商品类别',
          children: [
            {label: '查看', key: 'viewCommodityCategory',},
            {label: '新增', key: 'addCommodityCategory',},
            {label: '编辑', key: 'editCommodityCategory',},
            {label: '删除', key: 'deleteCommodityCategory',},
            // {label: '导出', key: 'exportCommodityCategory',},
          ],
        }, {
          label: '商品档案',
          children: [
            {label: '查看', key: 'viewCommodity',},
            {label: '新增', key: 'addCommodity',},
            {label: '编辑', key: 'editCommodity',},
            {label: '删除', key: 'deleteCommodity',},
            {label: '导出', key: 'exportCommodity',},
            {label: '打印', key: 'printCommodity',},
          ],
        }, {
          label: '商品回收站',
          children: [
            {label: '查看', key: 'viewCommodityGarbage',},
            // {label: '新增', key: 'addCommodityGarbage',},
            {label: '编辑', key: 'editCommodityGarbage',},
            {label: '删除', key: 'deleteCommodityGarbage',},
            {label: '导出', key: 'exportCommodityGarbage',},
            // {label: '打印', key: 'printCommodityGarbage',},
          ],
        }, {
          label: '门店配置',
          children: [
            {label: '查看', key: 'viewShopCommodity',},
            // {label: '新增', key: '',},
            {label: '编辑', key: 'editShopCommodity',},
            // {label: '删除', key: '',},
            {label: '导出', key: 'exportShopCommodity',},
            // {label: '打印', key: '',},
          ],
        }, {
          label: '供应商类别',
          children: [
            {label: '查看', key: 'viewCompanyCategory',},
            {label: '新增', key: 'addCompanyCategory',},
            {label: '编辑', key: 'editCompanyCategory',},
            {label: '删除', key: 'deleteCompanyCategory',},
            {label: '导出', key: 'exportCompanyCategory',},
            // {label: '打印', key: '',},
          ],
        }, {
          label: '供应商档案',
          children: [
            {label: '查看', key: 'viewCompany',},
            {label: '新增', key: 'addCompany',},
            {label: '编辑', key: 'editCompany',},
            {label: '删除', key: 'deleteCompany',},
            {label: '导出', key: 'exportCompany',},
            {label: '打印', key: 'printCompany',},
          ],
        }, {
          label: '客户类别',
          children: [
            {label: '查看', key: 'viewClientCategory',},
            {label: '新增', key: 'addClientCategory',},
            {label: '编辑', key: 'editClientCategory',},
            {label: '删除', key: 'deleteClientCategory',},
            // {label: '导出', key: 'exportClientCategory',},
            // {label: '打印', key: '',},
          ],
        }, {
          label: '客户档案',
          children: [
            {label: '查看', key: 'viewClient',},
            {label: '新增', key: 'addClient',},
            {label: '编辑', key: 'editClient',},
            {label: '删除', key: 'deleteClient',},
            {label: '导出', key: 'exportClient',},
            {label: '打印', key: 'printClient',},
          ],
        }, {
          label: '性质',
          children: [
            {label: '查看', key: 'viewNature',},
            {label: '新增', key: 'addNature',},
            {label: '编辑', key: 'editNature',},
            {label: '删除', key: 'deleteNature',},
            // {label: '导出', key: 'exportNature',},
            // {label: '打印', key: '',},
          ],
        },
      ],
    },
    {
      label: '质量管理',
      hide: !isGlasses(),
      children: [{label: '查看', key: 'viewQuality',},
        {label: '新增', key: 'addQuality',},
        {label: '编辑', key: 'editQuality',},
        {label: '删除', key: 'deleteQuality',},
        {label: '审核', key: 'checkQuality',},
        {label: '反审', key: 'reverseQuality',},
        {label: '导出', key: 'exportQuality',},
        {label: '打印', key: 'printQuality',},
      ],
    },
    /*
    {
      label: '加盟管理',
      children: [{
        label: '配送申请单',
        children: [{label: '查看', key: 'viewDeliveryApplication',},
          {label: '新增', key: 'addDeliveryApplication',},
          {label: '编辑', key: 'editDeliveryApplication',},
          {label: '删除', key: 'deleteDeliveryApplication',},
          {label: '审核', key: 'checkDeliveryApplication',},
          {label: '反审', key: 'reverseDeliveryApplication',},
          {label: '导出', key: 'exportDeliveryApplication',},
          {label: '打印', key: 'printDeliveryApplication',},
        ],
      }, {
        label: '配送申请单报表',
        children: [{label: '查看', key: 'viewDeliveryApplicationReport',},
          {label: '导出', key: 'exportDeliveryApplicationReport',},
          {label: '打印', key: 'printDeliveryApplicationReport',},
        ],
      }, {
        label: '配送单',
        children: [{label: '查看', key: 'viewDelivery',},
          {label: '新增', key: 'addDelivery',},
          {label: '编辑', key: 'editDelivery',},
          {label: '删除', key: 'deleteDelivery',},
          {label: '审核', key: 'checkDelivery',},
          {label: '反审', key: 'reverseDelivery',},
          {label: '导出', key: 'exportDelivery',},
          {label: '打印', key: 'printDelivery',},
        ],
      },  {
        label: '配送单报表',
        children: [{label: '查看', key: 'exportDeliveryReport',},
          {label: '导出', key: 'viewDeliveryReport',},
          {label: '打印', key: 'printDeliveryReport',},
        ],
      }, {
      label: '门店退货单',
      children: [{label: '查看', key: 'viewDeliveryRefund',},
        {label: '新增', key: 'addDeliveryRefund',},
        {label: '编辑', key: 'editDeliveryRefund',},
        {label: '删除', key: 'deleteDeliveryRefund',},
        {label: '审核', key: 'checkDeliveryRefund',},
        {label: '反审', key: 'reverseDeliveryRefund',},
        {label: '导出', key: 'exportDeliveryRefund',},
        {label: '打印', key: 'printDeliveryRefund',},
      ],
    },  {
      label: '门店退货单报表',
      children: [{label: '查看', key: 'viewDeliveryRefundReport',},
        {label: '导出', key: 'exportDeliveryRefundReport',},
        {label: '打印', key: 'printDeliveryRefundReport',},
      ],
    },
  ],
    },
    */
    {
      label: '采购管理',
      children: [{
        label: '供应商账单',
        children: [{label: '查看', key: 'viewCompanyBill',},
          {label: '导出', key: 'exportCompanyBill',},
          {label: '打印', key: 'printCompanyBill',},
        ],
      }, {
        label: '供应商结算单',
        children: [{label: '查看', key: 'viewCompanySettlementPurchase',},
          {label: '新增', key: 'addCompanySettlementPurchase',},
          {label: '编辑', key: 'editCompanySettlementPurchase',},
          {label: '删除', key: 'deleteCompanySettlementPurchase',},
          {label: '审核', key: 'checkCompanySettlementPurchase',},
          {label: '反审', key: 'reverseCompanySettlementPurchase',},
          {label: '导出', key: 'exportCompanySettlementPurchase',},
          {label: '打印', key: 'printCompanySettlementPurchase',},
        ],
      }, {
        label: '代销对账单',
        children: [{label: '查看', key: 'viewCompanyProxyOrder',},
          {label: '新增', key: 'addCompanyProxyOrder',},
          {label: '编辑', key: 'editCompanyProxyOrder',},
          {label: '删除', key: 'deleteCompanyProxyOrder',},
          {label: '审核', key: 'checkCompanyProxyOrder',},
          {label: '导出', key: 'exportCompanyProxyOrder',},
          {label: '打印', key: 'printCompanyProxyOrder',},
        ],
      }, {
        label: '代销对账单报表',
        children: [{label: '查看', key: 'viewCompanyProxyOrderReport',},
          {label: '导出', key: 'exportCompanyProxyOrderReport',},
          {label: '打印', key: 'printCompanyProxyOrderReport',},
        ],
      }, {
        label: '联营对账单',
        children: [{label: '查看', key: 'viewCompanyJointOrder',},
          {label: '新增', key: 'addCompanyJointOrder',},
          {label: '编辑', key: 'editCompanyJointOrder',},
          {label: '删除', key: 'deleteCompanyJointOrder',},
          {label: '审核', key: 'checkCompanyJointOrder',},
          {label: '导出', key: 'exportCompanyJointOrder',},
          {label: '打印', key: 'printCompanyJointOrder',},
        ],
      }, {
        label: '联营对账单报表',
        children: [{label: '查看', key: 'viewCompanyJointOrderReport',},
          {label: '导出', key: 'exportCompanyJointOrderReport',},
          {label: '打印', key: 'printCompanyJointOrderReport',},
        ],
      }, {
        label: '供应商预支账单',
        children: [{label: '查看', key: 'viewCompanyPurchasePrepaid',},
          {label: '新增', key: 'addCompanyPurchasePrepaid',},
          {label: '导出', key: 'exportCompanyPurchasePrepaid',},
          {label: '打印', key: 'printCompanyPurchasePrepaid',},
        ],
      }, {
        label: '订货单',
        children: [{label: '查看', key: 'viewPurchaseReservationOrder',},
          {label: '新增', key: 'addPurchaseReservationOrder',},
          {label: '编辑', key: 'editPurchaseReservationOrder',},
          {label: '删除', key: 'deletePurchaseReservationOrder',},
          {label: '审核', key: 'checkPurchaseReservationOrder',},
          {label: '反审', key: 'reversePurchaseReservationOrder',},
          {label: '导出', key: 'exportPurchaseReservationOrder',},
          {label: '打印', key: 'printPurchaseReservationOrder',},
        ],
      }, {
        label: '订货单报表',
        children: [{label: '查看', key: 'viewPurchaseReservationOrderReport',},
          {label: '导出', key: 'exportPurchaseReservationOrderReport',},
          {label: '打印', key: 'printPurchaseReservationOrderReport',},
        ],

      }, {
        label: '收货单',
        hide: !isGlasses(),
        children: [{label: '查看', key: 'viewPurchaseReservationReceive',},
          {label: '新增', key: 'addPurchaseReservationReceive',},
          {label: '编辑', key: 'editPurchaseReservationReceive',},
          {label: '删除', key: 'deletePurchaseReservationReceive',},
          {label: '审核', key: 'checkPurchaseReservationReceive',},
          {label: '反审', key: 'reversePurchaseReservationReceive',},
          {label: '导出', key: 'exportPurchaseReservationReceive',},
          {label: '打印', key: 'printPurchaseReservationReceive',},
        ],
      }, {
        label: '收货单报表',
        hide: !isGlasses(),
        children: [{label: '查看', key: 'viewPurchaseReservationReceiveReport',},
          {label: '导出', key: 'exportPurchaseReservationReceiveReport',},
          {label: '打印', key: 'printPurchaseReservationReceiveReport',},
        ],
      }, {
        label: '验收单',
        hide: !isGlasses(),
        children: [{label: '查看', key: 'viewPurchaseReservationCheck',},
          {label: '新增', key: 'addPurchaseReservationCheck',},
          {label: '编辑', key: 'editPurchaseReservationCheck',},
          {label: '删除', key: 'deletePurchaseReservationCheck',},
          {label: '审核', key: 'checkPurchaseReservationCheck',},
          {label: '反审', key: 'reversePurchaseReservationCheck',},
          {label: '导出', key: 'exportPurchaseReservationCheck',},
          {label: '打印', key: 'printPurchaseReservationCheck',},
        ],
      }, {
        label: '验收单报表',
        hide: !isGlasses(),
        children: [{label: '查看', key: 'viewPurchaseReservationCheckReport',},
          {label: '导出', key: 'exportPurchaseReservationCheckReport',},
          {label: '打印', key: 'printPurchaseReservationCheckReport',},
        ],
      }, {
        label: '入库单',
        hide: !isGlasses(),
        children: [{label: '查看', key: 'viewPurchaseReservationPurchase',},
          {label: '新增', key: 'addPurchaseReservationPurchase',},
          {label: '编辑', key: 'editPurchaseReservationPurchase',},
          {label: '删除', key: 'deletePurchaseReservationPurchase',},
          {label: '审核', key: 'checkPurchaseReservationPurchase',},
          {label: '反审', key: 'reversePurchaseReservationPurchase',},
          {label: '导出', key: 'exportPurchaseReservationPurchase',},
          {label: '打印', key: 'printPurchaseReservationPurchase',},
        ],
      }, {
        label: '入库单报表',
        hide: !isGlasses(),
        children: [{label: '查看', key: 'viewPurchaseReservationPurchaseReport',},
          {label: '导出', key: 'exportPurchaseReservationPurchaseReport',},
          {label: '打印', key: 'printPurchaseReservationPurchaseReport',},
        ],
      }, {
        label: isGlasses() ? '入库审核' : '入库单',
        children: [{label: '查看', key: 'viewMaterialPurchasePurchase',},
          {label: '新增', key: 'addMaterialPurchasePurchase',},
          {label: '编辑', key: 'editMaterialPurchasePurchase',},
          {label: '删除', key: 'deleteMaterialPurchasePurchase',},
          {label: '审核', key: 'checkMaterialPurchasePurchase',},
          {label: '反审', key: 'reverseMaterialPurchasePurchase',},
          {label: '导出', key: 'exportMaterialPurchasePurchase',},
          {label: '打印', key: 'printMaterialPurchasePurchase',},
        ],
      }, {
        label: isGlasses() ? '入库审核报表' : '入库单报表',
        children: [{label: '查看', key: 'viewMaterialPurchasePurchaseReport',},
          {label: '导出', key: 'exportMaterialPurchasePurchaseReport',},
          {label: '打印', key: 'printMaterialPurchasePurchaseReport',},
        ],
      }, {
        label: '退货单',
        hide: !isGlasses(),
        children: [{label: '查看', key: 'viewPurchaseReservationRefund',},
          {label: '新增', key: 'addPurchaseReservationRefund',},
          {label: '编辑', key: 'editPurchaseReservationRefund',},
          {label: '删除', key: 'deletePurchaseReservationRefund',},
          {label: '审核', key: 'checkPurchaseReservationRefund',},
          {label: '反审', key: 'reversePurchaseReservationRefund',},
          {label: '导出', key: 'exportPurchaseReservationRefund',},
          {label: '打印', key: 'printPurchaseReservationRefund',},
        ],
      }, {
        label: '退货单报表',
        hide: !isGlasses(),
        children: [{label: '查看', key: 'viewPurchaseReservationRefundReport',},
          {label: '导出', key: 'exportPurchaseReservationRefundReport',},
          {label: '打印', key: 'printPurchaseReservationRefundReport',},
        ],

      }, {
        label: isGlasses() ? '退货审核' : '退货单',
        children: [{label: '查看', key: 'viewMaterialPurchasePurchaseRefund',},
          {label: '新增', key: 'addMaterialPurchasePurchaseRefund',},
          {label: '编辑', key: 'editMaterialPurchasePurchaseRefund',},
          {label: '删除', key: 'deleteMaterialPurchasePurchaseRefund',},
          {label: '审核', key: 'checkMaterialPurchasePurchaseRefund',},
          {label: '反审', key: 'reverseMaterialPurchasePurchaseRefund',},
          {label: '导出', key: 'exportMaterialPurchasePurchaseRefund',},
          {label: '打印', key: 'printMaterialPurchasePurchaseRefund',},
        ],
      }, {
        label: isGlasses() ? '退货审核报表' : '退货单报表',
        children: [{label: '查看', key: 'viewMaterialPurchasePurchaseRefundReport',},
          {label: '导出', key: 'exportMaterialPurchasePurchaseRefundReport',},
          {label: '打印', key: 'printMaterialPurchasePurchaseRefundReport',},
        ],
      },
      ],
    },
    {
      label: '销售管理',
      children: [{
        label: '客户账单',
        children: [{label: '查看', key: 'viewClientBill',},
          {label: '导出', key: 'exportClientBill',},
          {label: '打印', key: 'printClientBill',},
        ],
      }, {
        label: '客户结算单',
        children: [{label: '查看', key: 'viewCompanySettlementSales',},
          {label: '新增', key: 'addCompanySettlementSales',},
          {label: '编辑', key: 'editCompanySettlementSales',},
          {label: '删除', key: 'deleteCompanySettlementSales',},
          {label: '审核', key: 'checkCompanySettlementSales',},
          {label: '反审', key: 'reverseCompanySettlementSales',},
          {label: '导出', key: 'exportCompanySettlementSales',},
          {label: '打印', key: 'printCompanySettlementSales',},
        ],
      }, {
        label: '客户预付账单',
        children: [{label: '查看', key: 'viewCompanySalesPrepaid',},
          {label: '新增', key: 'addCompanySalesPrepaid',},
          {label: '导出', key: 'exportCompanySalesPrepaid',},
          {label: '打印', key: 'printCompanySalesPrepaid',},
        ],
      }, {
        label: '销售订单',
        children: [{label: '查看', key: 'viewPurchaseReservationSalesOrder',},
          {label: '新增', key: 'addPurchaseReservationSalesOrder',},
          {label: '编辑', key: 'editPurchaseReservationSalesOrder',},
          {label: '删除', key: 'deletePurchaseReservationSalesOrder',},
          {label: '审核', key: 'checkPurchaseReservationSalesOrder',},
          {label: '反审', key: 'reversePurchaseReservationSalesOrder',},
          {label: '导出', key: 'exportPurchaseReservationSalesOrder',},
          {label: '打印', key: 'printPurchaseReservationSalesOrder',},
        ],
      }, {
        label: '销售订单报表',
        children: [{label: '查看', key: 'viewPurchaseReservationSalesOrderReport',},
          {label: '导出', key: 'exportPurchaseReservationSalesOrderReport',},
          {label: '打印', key: 'printPurchaseReservationSalesOrderReport',},
        ],
      }, {
        label: '销售订货审核',
        hide: !isGlasses(),
        children: [{label: '查看', key: 'viewPurchaseReservationSalesCheck',},
          {label: '新增', key: 'addPurchaseReservationSalesCheck',},
          {label: '编辑', key: 'editPurchaseReservationSalesCheck',},
          {label: '删除', key: 'deletePurchaseReservationSalesCheck',},
          {label: '审核', key: 'checkPurchaseReservationSalesCheck',},
          {label: '反审', key: 'reversePurchaseReservationSalesCheck',},
          {label: '导出', key: 'exportPurchaseReservationSalesCheck',},
          {label: '打印', key: 'printPurchaseReservationSalesCheck',},
        ],
      }, {
        label: '销售订货审核报表',
        hide: !isGlasses(),
        children: [{label: '查看', key: 'viewPurchaseReservationSalesCheckReport',},
          {label: '导出', key: 'exportPurchaseReservationSalesCheckReport',},
          {label: '打印', key: 'printPurchaseReservationSalesCheckReport',},
        ],
      }, {
        label: '销售单',
        hide: !isGlasses(),
        children: [{label: '查看', key: 'viewPurchaseReservationSales',},
          {label: '新增', key: 'addPurchaseReservationSales',},
          {label: '编辑', key: 'editPurchaseReservationSales',},
          {label: '删除', key: 'deletePurchaseReservationSales',},
          {label: '审核', key: 'checkPurchaseReservationSales',},
          {label: '反审', key: 'reversePurchaseReservationSales',},
          {label: '导出', key: 'exportPurchaseReservationSales',},
          {label: '打印', key: 'printPurchaseReservationSales',},
        ],
      }, {
        label: '销售单细报表',
        hide: !isGlasses(),
        children: [{label: '查看', key: 'viewPurchaseReservationSalesReport',},
          {label: '导出', key: 'exportPurchaseReservationSalesReport',},
          {label: '打印', key: 'printPurchaseReservationSalesReport',},
        ],
      }, {
        label: isGlasses() ? '销售出库复核' : '销售单',
        children: [{label: '查看', key: 'viewMaterialPurchaseSales',},
          {label: '新增', key: 'addMaterialPurchaseSales',},
          {label: '编辑', key: 'editMaterialPurchaseSales',},
          {label: '删除', key: 'deleteMaterialPurchaseSales',},
          {label: '审核', key: 'checkMaterialPurchaseSales',},
          {label: '反审', key: 'reverseMaterialPurchaseSales',},
          {label: '导出', key: 'exportMaterialPurchaseSales',},
          {label: '打印', key: 'printMaterialPurchaseSales',},
        ],
      }, {
        label: isGlasses() ? '销售出库复核报表' : '销售单报表',
        children: [{label: '查看', key: 'viewMaterialPurchaseSalesReport',},
          {label: '导出', key: 'exportMaterialPurchaseSalesReport',},
          {label: '打印', key: 'printMaterialPurchaseSalesReport',},
        ],
      }, {
        label: '销售退货单',
        hide: !isGlasses(),
        children: [{label: '查看', key: 'viewPurchaseReservationSalesRefund',},
          {label: '新增', key: 'addPurchaseReservationSalesRefund',},
          {label: '编辑', key: 'editPurchaseReservationSalesRefund',},
          {label: '删除', key: 'deletePurchaseReservationSalesRefund',},
          {label: '审核', key: 'checkPurchaseReservationSalesRefund',},
          {label: '反审', key: 'reversePurchaseReservationSalesRefund',},
          {label: '导出', key: 'exportPurchaseReservationSalesRefund',},
          {label: '打印', key: 'printPurchaseReservationSalesRefund',},
        ],
      }, {
        label: '销售退货单报表',
        hide: !isGlasses(),
        children: [{label: '查看', key: 'viewPurchaseReservationSalesRefundReport',},
          {label: '导出', key: 'exportPurchaseReservationSalesRefundReport',},
          {label: '打印', key: 'printPurchaseReservationSalesRefundReport',},
        ],
      }, {
        label: isGlasses() ? '销售退货验收' : '销售退货单',
        children: [{label: '查看', key: 'viewMaterialPurchaseSalesRefund',},
          {label: '新增', key: 'addMaterialPurchaseSalesRefund',},
          {label: '编辑', key: 'editMaterialPurchaseSalesRefund',},
          {label: '删除', key: 'deleteMaterialPurchaseSalesRefund',},
          {label: '审核', key: 'checkMaterialPurchaseSalesRefund',},
          {label: '反审', key: 'reverseMaterialPurchaseSalesRefund',},
          {label: '导出', key: 'exportMaterialPurchaseSalesRefund',},
          {label: '打印', key: 'printMaterialPurchaseSalesRefund',},
        ],
      }, {
        label: isGlasses() ? '销售退货验收报表' : '销售退货单报表',
        children: [{label: '查看', key: 'viewMaterialPurchaseSalesRefundReport',},
          {label: '导出', key: 'exportMaterialPurchaseSalesRefundReport',},
          {label: '打印', key: 'printMaterialPurchaseSalesRefundReport',},
        ],
      },
      ],
    },
    {
      label: '库存管理',
      children: [{
        label: '库存报表',
        children: [{label: '查看', key: 'viewStockReport',},
          {label: '导出', key: 'exportStockReport',},
          {label: '打印', key: 'printStockReport',},
        ],
      }, {
        label: isHD() ? '进销存流水表' : '进销存变动表',
        children: [{label: '查看', key: 'viewStockDetailReport',},
          {label: '导出', key: 'exportStockDetailReport',},
          {label: '打印', key: 'printStockDetailReport',},
        ],
      }, {
        label: '成本变更单',
        children: [{label: '查看', key: 'viewStockCostCorrect',},
          {label: '新增', key: 'addStockCostCorrect',},
          {label: '编辑', key: 'editStockCostCorrect',},
          {label: '删除', key: 'deleteStockCostCorrect',},
          {label: '审核', key: 'checkStockCostCorrect',},
          // {label: '反审', key: 'reverseStockCostCorrect',},
          {label: '导出', key: 'exportStockCostCorrect',},
          {label: '打印', key: 'printStockCostCorrect',},
        ],
      }, {
        label: '成本变更单报表',
        children: [{label: '查看', key: 'viewStockCostCorrectReport',},
          {label: '导出', key: 'exportStockCostCorrectReport',},
          {label: '打印', key: 'printStockCostCorrectReport',},
        ],
      }, {
        label: '损溢单',
        children: [{label: '查看', key: 'viewStockLossLoss',},
          {label: '新增', key: 'addStockLossLoss',},
          {label: '编辑', key: 'editStockLossLoss',},
          {label: '删除', key: 'deleteStockLossLoss',},
          {label: '审核', key: 'checkStockLossLoss',},
          // {label: '反审', key: 'reverseStockLossLoss',},
          {label: '导出', key: 'exportStockLossLoss',},
          {label: '打印', key: 'printStockLossLoss',},
        ],
      }, {
        label: '损溢单报表',
        children: [{label: '查看', key: 'viewStockLossLossReport',},
          {label: '导出', key: 'exportStockLossLossReport',},
          {label: '打印', key: 'printStockLossLossReport',},
        ],
      }, {
        label: '盘点单',
        children: [{label: '查看', key: 'viewStockInventory',},
          {label: '新增', key: 'addStockInventory',},
          {label: '编辑', key: 'editStockInventory',},
          {label: '删除', key: 'deleteStockInventory',},
          {label: '审核', key: 'checkStockInventory',},
          // {label: '反审', key: 'reverseStockInventory',},
          {label: '导出', key: 'exportStockInventory',},
          {label: '打印', key: 'printStockInventory',},
        ],
      }, {
        label: '盘点单报表',
        children: [{label: '查看', key: 'viewStockInventoryReport',},
          {label: '导出', key: 'exportStockInventoryReport',},
          {label: '打印', key: 'printStockInventoryReport',},
        ],
      }, {
        label: '调拨申请单',
        children: [{label: '查看', key: 'viewStockAllocationApplication',},
          {label: '新增', key: 'addStockAllocationApplication',},
          {label: '编辑', key: 'editStockAllocationApplication',},
          {label: '删除', key: 'deleteStockAllocationApplication',},
          {label: '审核', key: 'checkStockAllocationApplication',},
          {label: '反审', key: 'reverseStockAllocationApplication',},
          {label: '导出', key: 'exportStockAllocationApplication',},
          {label: '打印', key: 'printStockAllocationApplication',},
        ],
      }, {
        label: '调拨申请单报表',
        children: [{label: '查看', key: 'viewStockAllocationApplicationReport',},
          {label: '导出', key: 'exportStockAllocationApplicationReport',},
          {label: '打印', key: 'printStockAllocationApplicationReport',},
        ],
      }, {
        label: '调拨收货单',
        children: [{label: '查看', key: 'viewStockAllocationAllocation',},
          {label: '新增', key: 'addStockAllocationAllocation',},
          {label: '编辑', key: 'editStockAllocationAllocation',},
          {label: '删除', key: 'deleteStockAllocationAllocation',},
          {label: '审核', key: 'checkStockAllocationAllocation',},
          {label: '导出', key: 'exportStockAllocationAllocation',},
          {label: '打印', key: 'printStockAllocationAllocation',},
        ],
      }, {
        label: '调拨收货单报表',
        children: [{label: '查看', key: 'viewStockAllocationAllocationReport',},
          {label: '导出', key: 'exportStockAllocationAllocationReport',},
          {label: '打印', key: 'printStockAllocationAllocationReport',},
        ],
      }, {
        label: '收支记录',
        children: [{label: '查看', key: 'viewStockBillRecord',},
          {label: '导出', key: 'exportStockBillRecord',},
          {label: '打印', key: 'printStockBillRecord',},
        ],
      },
        /* {
        label: '组合单',
        children: [{label: '查看', key: 'viewStockPack',},
          {label: '新增', key: 'addStockPack',},
          {label: '编辑', key: 'editStockPack',},
          {label: '删除', key: 'deleteStockPack',},
          {label: '审核', key: 'checkStockPack',},
          {label: '导出', key: 'exportStockPack',},
          {label: '打印', key: 'printStockPack',},
        ],
      }, {
         label: '组合单报表',
         children: [{label: '查看', key: 'viewStockPackReport',},
           {label: '导出', key: 'exportStockPackReport',},
           {label: '打印', key: 'printStockPackReport',},
         ],
       }, {
         label: '拆分单',
         children: [{label: '查看', key: 'viewStockSplit',},
           {label: '新增', key: 'addStockSplit',},
           {label: '编辑', key: 'editStockSplit',},
           {label: '删除', key: 'deleteStockSplit',},
           {label: '审核', key: 'checkStockSplit',},
           {label: '导出', key: 'exportStockSplit',},
           {label: '打印', key: 'printStockSplit',},
         ],
       }, {
         label: '拆分单报表',
         children: [{label: '查看', key: 'viewStockSplitReport',},
           {label: '导出', key: 'exportStockSplitReport',},
           {label: '打印', key: 'printStockSplitReport',},
         ],
       },
         */
      ],
    },
    {
      label: '会员管理',
      children: [
        {
          label: '会员设置',
          key: 'memberConfig',
          isLine: true, // 表示 单独一行 不 浮动 因为浮动只判断第一个 同一个数组的都要加
        }, {
          label: '会员操作',
          isLine: true,
          children: [
            {label: '修改密码', key: 'memberOperatePassword',},
            {label: '激活', key: 'memberOperateActivate',},
            {label: '充值', key: 'memberOperateRecharge',},
            {label: '消费', key: 'memberOperateConsume',},
            {label: '赠送积分', key: 'memberOperateGiveIntegral',},
            {label: '赠送金额', key: 'memberOperateGiveAmount',},
            {label: '积分调整', className: 'custom-tree-node', key: 'memberOperateIntegral',},
            {label: '寄存', key: 'memberOperateDeposit',},
            {label: '领取', key: 'memberOperateGet',},
            {label: '退卡', key: 'memberOperateReturn',},
            {label: '次卡消费', key: 'memberOperateOncecardConsume',},
            {label: '次卡销售', key: 'memberOperateOncecardSell',},
            {label: '礼品兑换', className: 'custom-tree-node', key: 'memberOperateGift',},
            {label: '停用', key: 'memberOperateDisable',},
          ],
        }, {
          label: '会员卡等级',
          isLine: true,
          children: [
            {label: '新增', key: 'addMemberLevel',},
            {label: '编辑', key: 'editMemberLevel',},
            {label: '删除', key: 'deleteMemberLevel',},
          ],
        }, {
          label: '会员档案',
          isLine: true,
          children: [{label: '查看', key: 'viewMember',},
            {label: '新增', key: 'addMember',},
            {label: '编辑', key: 'editMember',},
            {label: '删除', key: 'deleteMember',},
            {label: '导出', key: 'exportMember',},
            {label: '打印', key: 'printMember',},
          ],
        }, {
          label: '充值方案',
          isLine: true,
          children: [
            {label: '新增', key: 'addMemberRechargePlan',},
            {label: '编辑', key: 'editMemberRechargePlan',},
            {label: '删除', key: 'deleteMemberRechargePlan',},
          ],
        }, {
          label: '会员次卡',
          isLine: true,
          children: [
            {label: '新增', key: 'addMemberOnceCard',},
            {label: '编辑', key: 'editMemberOnceCard',},
            {label: '删除', key: 'deleteMemberOnceCard',},
          ],
        }, {
          label: '会员卡礼品',
          isLine: true,
          children: [
            {label: '新增', key: 'addMemberGift',},
            {label: '编辑', key: 'editMemberGift',},
            {label: '删除', key: 'deleteMemberGift',},
          ],
        }, {
          label: '会员验光单',
          isLine: true,
          children: [
            {label: '查看', key: 'viewOptometryReview',},
            {label: '新增', key: 'addOptometryReview',},
            {label: '编辑', key: 'editOptometryReview',},
            {label: '删除', key: 'deleteOptometryReview',},
            {label: '导出', key: 'exportOptometryReview',},
            {label: '打印', key: 'printOptometryReview',},
          ],
        }, {
          label: '短信',
          isLine: true,
          children: [{label: '查看', key: 'viewMessage',},
            {label: '新增', key: 'addMessage',},
            {label: '编辑', key: 'editMessage',},
            {label: '删除', key: 'deleteMessage',},
            {label: '导出', key: 'exportMessage',},
            {label: '打印', key: 'printMessage',},
          ],
        }, {
          label: '会员挂账账单',
          isLine: true,
          children: [{label: '查看', key: 'viewMemberCredit',},
            {label: '新增', key: 'addMemberCredit',},
            // {label: '编辑', key: 'editMemberCredit',},
            {label: '删除', key: 'deleteMemberCredit',},
            {label: '审核', key: 'checkMemberCredit',},
            // {label: '反审', key: 'reverseMemberCredit',},
            {label: '导出', key: 'exportMemberCredit',},
            {label: '打印', key: 'printMemberCredit',},
          ],
        }, {
          label: '会员报表',
          isLine: true,
          children: [
            {label: '查看', key: 'viewMemberReport',},
            {label: '导出', key: 'exportMemberReport',},
            {label: '打印', key: 'printMemberReport',},
          ],
        }
      ],
    },
    {
      label: '系统设置',
      children: [
        {
          label: '页面设置',
          key: 'salesConfig',
          isLine: true,
        }, {
          label: '打印设置',
          key: 'printConfig',
          isLine: true,
        }, {
          label: '支付配置',
          key: 'payConfig',
          isLine: true,
        }, {
          label: '标签打印模板',
          isLine: true,
          children: [
            {label: '查看', key: 'viewPrintStyleTemplate',},
            {label: '新增', key: 'addPrintStyleTemplate',},
            {label: '编辑', key: 'editPrintStyleTemplate',},
            {label: '删除', key: 'deletePrintStyleTemplate',},
            {label: '打印', key: 'printPrintStyleTemplate',},
          ],
        },
      ],
    },
    {
      label: '公众号',
      children: [
        {label: '查看', key: 'viewWechat',},
        {label: '编辑', key: 'editWechat',},
      ]
    },
    {
      label: '小程序',
      children: [
        {
          label: '小程序设置',
          children: [
            {label: '查看', key: 'viewAppletConfig',},
            {label: '编辑', key: 'editAppletConfig',},
          ],
        },
        {
          label: '小程序商品',
          children: [
            {label: '查看', key: 'viewAppletCommodity',},
            {label: '新增', key: 'addAppletCommodity',},
            {label: '编辑', key: 'editAppletCommodity',},
            {label: '删除', key: 'deleteAppletCommodity',},
            {label: '导出', key: 'exportAppletCommodity',},
            {label: '打印', key: 'printAppletCommodity',},
          ],
        },
        {
          label: '小程序订单',
          children: [
            {label: '查看', key: 'viewAppletOrder',},
            {label: '编辑', key: 'editAppletOrder',},
            {label: '导出', key: 'exportAppletOrder',},
            {label: '打印', key: 'printAppletOrder',},
          ],
        },
        {
          label: '小程序评论',
          children: [
            {label: '查看', key: 'viewAppletComment',},
            {label: '编辑', key: 'editAppletComment',},
            {label: '导出', key: 'exportAppletComment',},
            {label: '打印', key: 'printAppletComment',},
          ],
        },
        {
          label: '小程序优惠券',
          children: [
            {label: '查看', key: 'viewAppletCoupon',},
            {label: '新增', key: 'addAppletCoupon',},
            {label: '编辑', key: 'editAppletCoupon',},
            {label: '删除', key: 'deleteAppletCoupon',},
            {label: '发放', key: 'sendAppletCoupon',},
            {label: '导出', key: 'exportAppletCoupon',},
            {label: '打印', key: 'printAppletCoupon',},
          ],
        },
      ],
    },
  ];
  return authorityTree;
}


/**
 * 计算两个日期之间的天数
 * @param dateString1  开始日期 yyyy-MM-dd
 * @param dateString2  结束日期 yyyy-MM-dd
 */
export function getDaysBetween(dateString1, dateString2) {
  var startDate = Date.parse(dateString1);
  var endDate = Date.parse(dateString2);
  // if (startDate > endDate) {
  //   return 0;
  // }
  if (startDate == endDate) {
    return 0;
  }
  var days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
  return isNaN(days) ? 0 : days;
}

export function addDayFn(dateStr, days) {
  days = isNaN(days) ? 0 : parseInt(days);
  dateStr = dateStr ? dateStr : null;
  return new Date(new Date(dateStr).getTime() + (days * 24 * 60 * 60 * 1000));
}

// 导入excel日期（变数字） 格式化
export function formatInputDate(numb, defaultDate) {
  if (!numb) {
    return defaultDate;
  }
  if (isNaN(numb)) {
    return timeFn(0, new Date(numb).getTime());
  }
  const old = numb - 1;
  const t = Math.round((old - Math.floor(old)) * 24 * 60 * 60);
  const time = new Date(1900, 0, old, 0, 0, t)
  return timeFn(0, time.getTime());
}

// 当前时间
export function timeFn(type, newDate) {
  function p(s) {
    return s < 10 ? '0' + s : s;
  }

  var myDate = new Date();
  if (newDate) myDate = new Date(newDate);
  //获取当前年
  var year = myDate.getFullYear();
  //获取当前月
  var month = myDate.getMonth() + 1;
  //获取当前日
  var date = myDate.getDate();
  var h = myDate.getHours(); //获取当前小时数(0-23)
  var m = myDate.getMinutes(); //获取当前分钟数(0-59)
  var s = myDate.getSeconds();
  var now = year + '-' + p(month) + "-" + p(date) + " " + p(h) + ':' + p(m) + ":" + p(s);
  if (type == 1) {
    now = year + '-' + p(month) + "-" + p(date);
  } else if (type == 2) {
    now = year + '年' + p(month) + "月" + p(date) + "日" + p(h) + '时' + p(m) + "分" + p(s) + '秒';
  } else if (type == 3) {
    var num = Math.floor(Math.random() * 10 + 1);//1-10的随机数
    var seconds = myDate.getMilliseconds();
    if (seconds < 100) {
      seconds = '0' + seconds;
    } else if (seconds < 10) {
      seconds = '00' + seconds;
    }
    now = year.toString().substring(2, 4) + '' + p(month) + '' + p(date) + '' + p(h) + '' + p(m) + '' + p(s) + seconds + num;
  } else if (type == 4) {
    now = p(month) + "-" + p(date) + " " + p(h) + ':' + p(m);
  } else if (type == 5) {
    now = year + '' + p(month) + "" + p(date) + "" + p(h) + '' + p(m) + "" + p(s);
  } else if (type == 6) {
    now = p(h) + ':' + p(m) + ":" + p(s);
  } else if (type == 7) {
    now = year + '' + p(month) + "" + p(date);
  } else if (type == 8) {
    // 获取一个月前的日期
    if (month == 1) {
      year--;
      month = 12;
    } else if (month == 3 && date > 28) {
      //三月要考虑是否为闰年
      month--;
      if (year % 4 == 0 && year % 100 != 0 || year % 400 == 0) {
        date = 29;
      } else {
        date = 28;
      }
    } else if ((month != 12 || month != 8 ) && date == 31) {
      //31号的月份要考虑上个月是否有31号
      month--;
      date = 30;
    } else {
      month--;
    }
    now = year + '-' + p(month) + "-" + p(date);
  } else if (type == 9) {
    now = year + '-' + p(month);
  }
  return now;
}

// 当日凌晨和最后一个小时
export function formatFn(temp) {
  let dale = 0;
  if (temp == 0) {//往前七天
    dale = new Date().setHours(0, 0, 0, 0);

  }
  if (temp == 1) {
    dale = new Date().setHours(23, 59, 59, 59);
  }
  var time = new Date(dale);
  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();
  var h = time.getHours();
  var mm = time.getMinutes();
  var s = time.getSeconds();
  // console.log(y,m,d,h,mm,s);
  return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d) + ' ' + (h < 10 ? '0' + h : h) + ':' + (mm <
  10 ? '0' + mm : mm) + ':' + (s < 10 ? '0' + s : s);
}

/*
 * @param fmt:时间格式
 */
Date.prototype.pattern = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, // 月份
    "d+": this.getDate(), // 日
    "h+": this.getHours() % 12 == 0 ? 12 : this.getHours() % 12, // 小时
    "H+": this.getHours(), // 小时
    "m+": this.getMinutes(), // 分
    "s+": this.getSeconds(), // 秒
    "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
    "S": this.getMilliseconds()
    // 毫秒
  };
  var week = {
    "0": "/u65e5",
    "1": "/u4e00",
    "2": "/u4e8c",
    "3": "/u4e09",
    "4": "/u56db",
    "5": "/u4e94",
    "6": "/u516d"
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? "/u661f/u671f" : "/u5468") : "") + week[this.getDay() + ""]);
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
  }
  return fmt;
};

// temp时间 1 今日，2 昨日，3 近7天 ，4 近31天，n传递的天数
export function recentDayFn (temp, type) {
	let dale = 0;

	if (temp == 1) {
		dale = new Date();
	} else if (temp == 2) {
		let currentDate = new Date();
		let old7Date = currentDate.setDate(currentDate.getDate() - 1);
		let dataTime = new Date(old7Date).setHours(0, 0, 0, 0);
		dale = dataTime;
	} else if (temp == 3) {
		let currentDate = new Date();
		let old7Date = currentDate.setDate(currentDate.getDate() - 7);
		let dataTime = new Date(old7Date).setHours(0, 0, 0, 0);
		dale = dataTime;
	} else if (temp == 4) {
		let currentDate = new Date();
		let old7Date = currentDate.setDate(currentDate.getDate() - 31);
		let dataTime = new Date(old7Date).setHours(0, 0, 0, 0);
		dale = dataTime;
	} else {
    let currentDate = new Date();
    let date = currentDate.setDate(currentDate.getDate() - temp);
    let dataTime = new Date(date).setHours(0, 0, 0, 0);
    dale = dataTime;
  }

	var time = new Date(dale);
	var y = time.getFullYear();
	var m = time.getMonth() + 1;
	var d = time.getDate();
	var h = time.getHours();
	var mm = time.getMinutes();
	var s = time.getSeconds();
	if (type) {//2022-05-13 00:00:00
		return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d) + ' ' + (h < 10 ? '0' + h : h) + ':' + (mm < 10 ? '0' + mm : mm) + ':' + (s < 10 ? '0' + s : s);
	} else {//2022-05-13
		return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d);
	}
}

export function formatDate(date, fmt) {
  date = new Date(date);
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
    }
  }
  return fmt;
};

function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}

export function weekEndDate(date) {
  let startDate = new Date(date).getTime() - 3600 * 1000 * 24;
  date = formatDate(startDate, 'yyyy-MM-dd');
  let endDate = new Date(date).getTime() + 3600 * 1000 * 24 * 6;
  let formatEndDate = formatDate(new Date(endDate), 'yyyy-MM-dd');
  return formatEndDate;
}


export function monthEndDate(date) {
  const month = [30, 26, 30, 29, 30, 29, 30, 30, 29, 30, 29, 30];
  let days = month[new Date(date).getMonth()];
  let endDate = new Date(date).getTime() + 3600 * 1000 * 24 * days;
  let formatEndDate = formatDate(new Date(endDate), 'yyyy-MM-dd');
  return formatEndDate;
}

export function printDownload(type) {
  // 'https://eye.ypos.vip/data/Lodop.zip';
  let protocol = 'http:';
  if (window.location.protocol.indexOf('https:') != -1) protocol = 'https:';
  let win32 = protocol + '//www.ypos.vip/download/lodop/install_lodop32.exe?t=' + (new Date().getTime());
  let win64 = protocol + '//www.ypos.vip/download/lodop/install_lodop64.exe?t=' + (new Date().getTime());
  if (type == null) {
    return isWin64() ? win64 : win32;
  }
  if (type = 'win32') {
    return win32;
  }
  if (type = 'win64') {
    return win64;
  }
  return 'http://www.lodop.net/download.html'
}

export function isWin64() {
  var agent = navigator.userAgent.toLowerCase();//获取window的CPU
  if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
    // console.log("win64");
    return true;
  }
  return false;
}

// base64加密
export function encryption(val) {
  if (val === '') return;
  let base = new Base64();
  let result = base.encode(val);
  return result;
}

// base64解密
export function decrypt(val) {
  if (val === '') return;
  let base = new Base64();
  let result = base.decode(val);
  return result;
}

function Base64() {
  // private property
  let _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  var _utf8_encode, _utf8_decode;

  // public method for encoding
  this.encode = function (input) {
    var output = "";
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;
    input = _utf8_encode(input);
    while (i < input.length) {
      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);
      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;
      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }
      output = output + _keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
    }
    return output;
  }

  // public method for decoding
  this.decode = function (input) {
    var output = "";
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0;
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    while (i < input.length) {
      enc1 = _keyStr.indexOf(input.charAt(i++));
      enc2 = _keyStr.indexOf(input.charAt(i++));
      enc3 = _keyStr.indexOf(input.charAt(i++));
      enc4 = _keyStr.indexOf(input.charAt(i++));
      chr1 = (enc1 << 2) | (enc2 >> 4);
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
      chr3 = ((enc3 & 3) << 6) | enc4;
      output = output + String.fromCharCode(chr1);
      if (enc3 != 64) {
        output = output + String.fromCharCode(chr2);
      }
      if (enc4 != 64) {
        output = output + String.fromCharCode(chr3);
      }
    }
    output = _utf8_decode(output);
    return output;
  }

  // private method for UTF-8 encoding
  _utf8_encode = function (string) {
    string = string.replace(/\r\n/g, "\n");
    var utftext = "";
    for (var n = 0; n < string.length; n++) {
      var c = string.charCodeAt(n);
      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if ((c > 127) && (c < 2048)) {
        utftext += String.fromCharCode((c >> 6) | 192);
        utftext += String.fromCharCode((c & 63) | 128);
      } else {
        utftext += String.fromCharCode((c >> 12) | 224);
        utftext += String.fromCharCode(((c >> 6) & 63) | 128);
        utftext += String.fromCharCode((c & 63) | 128);
      }
    }
    return utftext;
  }

  // private method for UTF-8 decoding
  _utf8_decode = function (utftext) {
    var string = "";
    var i = 0;
    var c = 0, c1 = 0, c2 = 0, c3 = 0;
    while (i < utftext.length) {
      c = utftext.charCodeAt(i);
      if (c < 128) {
        string += String.fromCharCode(c);
        i++;
      } else if ((c > 191) && (c < 224)) {
        c2 = utftext.charCodeAt(i + 1);
        string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
        i += 2;
      } else {
        c2 = utftext.charCodeAt(i + 1);
        c3 = utftext.charCodeAt(i + 2);
        string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        i += 3;
      }
    }
    return string;
  }
}

// 日期转时间戳
export function timeToTimestamp(time) {
  var date = new Date(time);
  return Date.parse(date);
}

export function isHanzi(c) {
  var re = /[^\u4E00-\u9FA5]/;
  if (re.test(c)) return false;
  return true;
}

// 数字转换中文大写
export function changeNumMoneyToChinese(money) {
  var cnNums = new Array("零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"); //汉字的数字
  var cnIntRadice = new Array("", "拾", "佰", "仟"); //基本单位
  var cnIntUnits = new Array("", "万", "亿", "兆"); //对应整数部分扩展单位
  var cnDecUnits = new Array("角", "分", "毫", "厘", "丝", "忽", "微"); //对应小数部分单位
  var cnInteger = "整"; //整数金额时后面跟的字符
  var cnIntLast = "元"; //整型完以后的单位
  var maxNum = 999999999999999.9999; //最大处理的数字
  var IntegerNum; //金额整数部分
  var DecimalNum; //金额小数部分
  var ChineseStr = ""; //输出的中文金额字符串
  var parts; //分离金额后用的数组，预定义
  var Symbol = "";//正负值标记
  if (money == "") {
    return "";
  }

  money = parseFloat(money);
  if (money >= maxNum) {
//		alert('超出最大处理数字');
    return "";
  }
  if (money == 0) {
    ChineseStr = cnNums[0] + cnIntLast + cnInteger;
    return ChineseStr;
  }
  if (money < 0) {
    money = -money;
    Symbol = "负 ";
  }
  money = money.toString(); //转换为字符串
  if (money.indexOf(".") == -1) {
    IntegerNum = money;
    DecimalNum = '';
  } else {
    parts = money.split(".");
    IntegerNum = parts[0];
    DecimalNum = parts[1].substr(0, 4);
  }
  if (parseInt(IntegerNum, 10) > 0) { //获取整型部分转换
    var zeroCount = 0;
    var IntLen = IntegerNum.length;
    for (var i = 0; i < IntLen; i++) {
      var n = IntegerNum.substr(i, 1);
      var p = IntLen - i - 1;
      var q = p / 4;
      var m = p % 4;
      if (n == "0") {
        zeroCount++;
      } else {
        if (zeroCount > 0) {
          ChineseStr += cnNums[0];
        }
        zeroCount = 0; //归零
        ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
      }
      if (m == 0 && zeroCount < 4) {
        ChineseStr += cnIntUnits[q];
      }
    }
    ChineseStr += cnIntLast;
    //整型部分处理完毕
  }
  if (DecimalNum != '') { //小数部分
    var decLen = DecimalNum.length;
    for (var i = 0; i < decLen; i++) {
      var n = DecimalNum.substr(i, 1);
      if (n != '0') {
        ChineseStr += cnNums[Number(n)] + cnDecUnits[i];
      }
    }
  }
  if (ChineseStr == '') {
    ChineseStr += cnNums[0] + cnIntLast + cnInteger;
  } else if (DecimalNum == '') {
    ChineseStr += cnInteger;
  }
  ChineseStr = Symbol + ChineseStr;
  return ChineseStr;
}

export function getPageSetInfo() {
  let info = {};
  let paramInfo = window.localStorage.getItem('paramInfo');
  if (paramInfo) {
    info = JSON.parse(paramInfo);
  } else {
    info = setData();
  }
  if (info.moduleOptometry == null) {
    info.moduleOptometry = true;
  }
  if (info.promotionManagement == null) {
    info.promotionManagement = isHD();
  }
  if (info.retailManagement == null) {
    info.retailManagement = isApparatus() ? false : true;
  }
  if (info.salesManagement == null) {
    info.salesManagement = isHD();
  }
  if (info.saveCheckFlag == null) {
    info.saveCheckFlag = true;
  }
  if (info.labelCode == null) {
    info.labelCode = 0;
  }
  if (info.materialPurchasePurchase == null) {
    info.materialPurchasePurchase = true;
  }
  if (info.materialPurchasePurchaseRefund == null) {
    info.materialPurchasePurchaseRefund == true;
  }
  if (info.materialPurchaseSales == null) {
    info.materialPurchaseSales == true;
  }
  if (info.materialPurchaseSalesRefund == null) {
    info.materialPurchaseSalesRefund = true;
  }
  if (info.purchaseReceive == null) {
    info.purchaseReceive = true;
  }
  if (info.purchaseCheck == null) {
    info.purchaseCheck = true;
  }
  if (info.handleEmployee == null) {
    info.handleEmployee = true;
  }
  if (info.warehouseKeeper == null) {
    info.warehouseKeeper = false;
  }
  if (info.salesGoods == null) {
    info.salesGoods = '0';
  }
  if (info.shortcutDisable == null) {
    info.shortcutDisable = false;
  }
  if (info.updateRetailPrice == null) {
    info.updateRetailPrice = isMedicine();
  }
  window.localStorage.setItem('paramInfo', JSON.stringify(info));
  return info;
}

// 系统设置参数
export function setData() {
  let data = {
    salesGoods: '0',
    cashPay: true,
    mamberPay: true,
    weChatPay: true,
    alipayPay: true,
    scanPay: true,
    openAccount: false,
    navShow: false,
    salesManagement: isHD(),
    retailManagement: !isApparatus(),
    moduleOptometry: true,
    remainCountShow: false,
    greaterZeroShow: false,
    remainCount: '0',// 库存不足：0允许，1禁止，2提示
    materialPurchasePurchase: true,
    materialPurchasePurchaseRefund: true,
    materialPurchaseSales: true,
    materialPurchaseSalesRefund: true,
    purchaseReceive: true,
    purchaseCheck: true,
    changeAmount: "100.00",// 最大找零金额
    wipeZeroShow: false,
    wipeZeroType: "1",
    wipeZeroValue: "0",
  }
  return data;
}

export function getUrlParam(key, Url) {
  var str = Url;
  if (str.startsWith("http")) {
    // 完整的url
    let index = str.lastIndexOf("?");
    if (index) {
      str = str.substring(index);
    }
  }
  if (str.startsWith("?")) {
    str = str.substring(1, str.length); // 获取URL中?之后的字符（去掉第一位的问号）
  }
  // 以&分隔字符串，获得类似name=xiaoli这样的元素数组
  var arr = str.split("&");
  var obj = new Object();
  // 将每一个数组元素以=分隔并赋给obj对象
  for (var i = 0; i < arr.length; i++) {
    var tmp_arr = arr[i].split("=");
    obj[decodeURIComponent(tmp_arr[0])] = decodeURIComponent(tmp_arr[1]);
  }
  return obj[key];
}

export function isPC() {
  try {
    let u = window.navigator.userAgent, app = window.navigator.appVersion;
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
    let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
      return true;
    }
    if (isIOS) {
      return true;
    }
  } catch (e) { }
  let isPC = getUrlParam('isPC', location.search);
  return isPC == 'true';
}

// 判断是否是单独器械版本
export function isApparatusVFn() {
  let v = getUrlParam('versionType', location.search);
  let host = window.location.host;
  let hasHost = host.indexOf('zmd.') != -1 || host.indexOf('localhost') != -1 || host.indexOf('127.0.0.1') != -1;
  return v == '38' && hasHost;
}

export function reqFn(_this, uri, listName, page = 1, pageSize = 50) {
  let data = {
    merchantId: _this.$store.state.merchantId,
    page: page,
    pageSize: pageSize,
    status: 0
  }

  _this.$http.post(interfaceFn() + uri,
  qs.stringify(data), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then((res) => {
    if (res.data.code == 0) {
      let list = res.data.data.list;
      if (page == 1) {
        _this[listName] = list;
      } else {
        _this[listName] = _this[listName].concat(list);
      }
    }
  });
}

// 下划线转换驼峰
export function toHump(name) {
  return name.replace(/\_(\w)/g, function (all, letter) {
    return letter.toUpperCase();
  });
}

// 驼峰转换下划线
function toLine(name) {
  return name.replace(/([A-Z])/g, "_$1").toLowerCase();
}


export function isStockPurchaseOrderFn(templateId) {
  switch (templateId) {
    // 采购
    case 213: // 订货
    case 214: // 收货
    case 216: // 退货
    case 215: // 验收
    case 201: // 入库
    case 203: // 入库审核
    case 205: // 退货审核
      return true;
  }
  return false;
}

export function isManageBatchesFn(templateId) {
  let result = true;
  switch (templateId) {
    // 采购
    case 213: // 订货
    case 214: // 收货
      result = false;
      break;

    // case 216: // 退货
    // case 215: // 验收
    // case 201: // 入库
    // case 203: // 入库审核
    // case 205: // 退货审核
    //   break;
    // 销售
    case 217: // 订货单
    case 218: // 订货审核
      result = false;
      break
    // case 202: // 销售
    // case 219: // 销售退货
    //   break
    // case 204: // 销售审核
    // case 206: // 销售退货验收
    // case 210: // 损溢单
    case 211: // 调拨申请单
      result = false;
      break;
    // case 212: // 调拨收货单
    // case 207: // 成本变更单
    // case 208: // 盘点单
    //   break;
    default:
  }
  return result;
}

export function isDateEnableOrder(id) {
  switch (id) {
    // 销售
    case 217: // 订货单
    case 218: // 订货审核
    case 202: // 销售
    case 204: // 销售审核

    case 212: // 调拨收货单
    case 210: // 损溢单
    case 2000: // 器械养护计划
    case 2002: // 器械停售通知
    case 2003: // 不合格医疗器械报告确认单
    case 2004: // 解除停售通知
    case 2005: // 报废器械销毁表
      return false;
  }
  return true;
}

export function isStockSaleOrder(id) {
  switch (id) {
    // 销售
    case 217: // 订货单
    case 218: // 订货审核
    case 202: // 销售
    case 219: // 销售退货
    case 204: // 销售审核
    case 206: // 销售退货验收
      return true;
  }
  return false;
}

export function getMatchPhone() {
  return isHD() ? '' : 'right';
}

export function getStockTemplateId(stockType) {
  switch (stockType) {
    // 采购
    case "purchase_reservation_order": // 订货
      return 213;
    case "purchase_reservation_receive": // 收货
      return 214;
    case 'purchase_reservation_check': // 验收
      return 215;
    case 'purchase_reservation_purchase' : // 入库
      return 201;
    case 'purchase_reservation_refund': // 退货
      return 216;
    case 'material_purchase_purchase' : // 入库审核
      return 203;
    case 'material_purchase_purchase_refund': // 退货审核
      return 205;
    // 销售
    case 'purchase_reservation_sales_order': // 订货单
      return 217;
    case 'purchase_reservation_sales_check': // 订货审核
      return 218;
    case 'purchase_reservation_sales': // 销售
      return 202;
    case 'purchase_reservation_sales_refund': // 销售退货
      return 219;
    // case 303:
    // case 313:
    // case 305:
    // case 307:
    // case 309:
    // case 315:
    // case 317:
    case 'material_purchase_sales': // 销售审核
      return 204;
    case 'material_purchase_sales_refund': // 销售退货验收
      return 206;
    case 'stock_loss_loss': // 损溢单
      return 210;
    case 'stock_allocation_application': // 调拨申请单
      return 211;
    case 'stock_allocation_allocation': // 调拨收货单
      return 212;
    case 'stock_cost_correct':
      return 207;
    case 'stock_inventory': // 盘点单
      return 208;
    default:
      return 0;
  }
}

export function getStockType(templateId) {
  switch (templateId) {
    // 采购
    case 213: // 订货
      return "purchase_reservation_order";
    case 214: // 收货
      return "purchase_reservation_receive";
    case 215: // 验收
      return 'purchase_reservation_check';
    case 201: // 入库
      return 'purchase_reservation_purchase';
    case 216: // 退货
      return 'purchase_reservation_refund';
    case 203: // 入库审核
      return 'material_purchase_purchase';
    case 205: // 退货审核
      return 'material_purchase_purchase_refund';
    // 销售
    case 217: // 订货单
      return 'purchase_reservation_sales_order';
    case 218: // 订货审核
      return 'purchase_reservation_sales_check';
    case 202: // 销售
      return 'purchase_reservation_sales';
    case 219: // 销售退货
      return 'purchase_reservation_sales_refund';
    // case 303:
    // case 313:
    // case 305:
    // case 307:
    // case 309:
    // case 315:
    // case 317:
    case 204: // 销售审核
      return 'material_purchase_sales';
    case 206: // 销售退货验收
      return 'material_purchase_sales_refund';
    case 210: // 损溢单
      return 'stock_loss_loss';
    case 325:
    case 306:
      return 'stock_loss_loss';
    case 211: // 调拨申请单
    case 323:
    case 324:
      return 'stock_allocation_application';
    case 212: // 调拨收货单
    case 321:
    case 322:
      return 'stock_allocation_allocation';
    case 207:
    case 327:
      return 'stock_cost_correct';
    case 208: // 盘点单
      return 'stock_inventory';
    default:
      return 'quality';
  }
}

export function getStockPriceKey(templateId) {
  switch (templateId) {
    // 采购
    case 213: // 订货
    case 214: // 收货
    case 215: // 验收
    case 201: // 入库
    case 216: // 退货
    case 203: // 入库审核
    case 205: // 退货审核
      return 'viewPurchasePrice';
    // 销售
    case 217: // 订货单
    case 218: // 订货审核
    case 202: // 销售
    case 219: // 销售退货
    // case 303:
    // case 313:
    // case 305:
    // case 307:
    // case 309:
    // case 315:
    // case 317:
    case 204: // 销售审核
    case 206: // 销售退货验收
      return 'viewWholesalePrice';
    case 210: // 损溢单
    case 325:
    case 306:
    case 211: // 调拨申请单
    case 323:
    case 324:
    case 212: // 调拨收货单
    case 321:
    case 322:
    case 207:
    case 327:
    case 208: // 盘点单
    default:
      return 'viewCostPrice';
  }
}

export function getStockOrderUrlFn(templateId, url) {
  let prefix = '';
  switch (templateId) {
    // 采购
    case 213: // 订货
    case 214: // 收货
    case 215: // 验收
    case 201: // 入库
    case 216: // 退货
      prefix = "/stock/purchase-reservation";
      break;
    case 203: // 入库审核
    case 205: // 退货审核
      prefix = "/stock/material-purchase";
      break;
    // 销售
    case 217: // 订货单
    case 218: // 订货审核
    case 202: // 销售
    case 219: // 销售退货
      prefix = "/stock/purchase-reservation";
      break
    case 303:
    case 313:
    case 305:
    case 307:
    case 309:
    case 315:
    case 317:
      prefix = "/stock/purchase-reservation";
      break
    case 204: // 销售审核
    case 206: // 销售退货验收
    case 301:
    case 311:
      prefix = "/stock/material-purchase";
      break
    case 210: // 损溢单
    case 325:
      prefix = "/stock/stock-loss";
      break;
    case 211: // 调拨申请单
    case 212: // 调拨收货单
    case 321:
    case 323:
      prefix = "/stock/stock-allocation";
      break;

    case  207:
    case 327:
      // 成本变更
      prefix = "/stock/stock-cost";
      break;
    case 208: // 盘点单
      prefix = "/stock/stock-inventory";
      break;
    case  241:
    case  245:
      prefix = "/orders";
      break;
    case 2000: // 保养计划
      prefix = "/stock/maintain-plan";
      break;
    case 2001: // 保养记录
      prefix = "/stock/maintain-record";
      break;
    case 2002: // 停售通知
      prefix = "/stock/stop-notice";
      break;
    case 2003: // 不合格医疗报告确认单
      prefix = "/stock/nonconformity-report";
      break;
    case 2004: // 解除停售通知
      prefix = "/stock/unstop-notice";
      break;
    case 2005: // 报废器械销毁表
      prefix = "/stock/scrap-destroy";
      break;
    case 2006: //器械召回记录
      prefix = "/stock/stock-recall";
      break;
    case 2007: //器械追回记录
      prefix = "/stock/take-back";
      break;
    case 2008: //过期器械回收登记表
      prefix = "/stock/overdue-recovery";
      break;
    case 2009: //器械拒收报告单
      prefix = "/stock/rejection-report";
      break;
    case 2010: //器械售后服务记录
      prefix = "/stock/after-service";
      break;
    case 2011: //器械质量投诉处理记录
      prefix = "/stock/quality-complaints";
      break;
    case 2012: //器械不良事件报告
      prefix = "/stock/event-report";
      break;
    case 2013: //器械质量跟踪及信息反馈记录
      prefix = "/stock/tracking-feedback";
      break;
    case 2014: //不合格器械停售锁定
      prefix = "/stock/stop-lock";
      break;
    case 2015: //器械质量事故调查处理报告记录
      prefix = "/stock/survey-report";
      break;
    case 3001: //员工健康档案
    case 3002: //员工健康检查汇总表
      prefix = "/stock/record-health";
      break;
    case 3003: //员工培训计划
      prefix = "/stock/record-training-plan";
      break;
    case 3004: //员工培训记录
      prefix = "/stock/record-training";
      break;
    case 3005: //湿度温度记录
      prefix = "/stock/record-temperature";
      break;
    case 3006: //企业设备一览表
      prefix = "/stock/record-equipment";
      break;
    case 3007: //制度检查考核记录
      prefix = "/stock/record-appraisal";
      break;
    case 3008: // 计量器具台账
      prefix = "/stock/record-measuring-device";
      break;
    case 3009: // 计量器具检定记录
      prefix = "/stock/record-measuring-device-check";
      break;
    case 3010: // 设备台账
      prefix = "/stock/record-device";
      break;
    case 3011: // 设备使用记录
      prefix = "/stock/record-device-used";
      break;
    case 3012: // 设备检修维护记录
      prefix = "/stock/record-device-check";
      break;
    default:
  }
  if (!url) {
    url = "/";
  }
  url = url.trim();
  if (!url.startsWith("/")) {
    url = '/' + url;
  }
  return prefix + url;
}

/**
 * 获取标签列表并显示
 * @param _this
 * @param $
 * @param labelSelectId
 * @param shopId
 * @param merchantId
 * */
export function getLabel(_this, $, labelSelectId, shopId, merchantId) {
  let width = _this.$refs.labelRef.offsetWidth - 222;
  let labelWidth = '';
  if (width >= 222) {
    labelWidth = 'margin: 10px 10px 0;width: 220px';
  } else {
    labelWidth = 'margin: 10px 10% 0;width: 80%';
  }

  _this.loading = true;
  _this.$http.get(interfaceFn() + '/printStyle/search?printStyle=2&page=1&pageSize=999&shopId=' + shopId
  + '&merchantId=' + merchantId).then((res) => {
    _this.loading = false;
    _this.labelList = res.data.rows;
    _this.labelShow = true;
    var ref = _this.$refs;

    var list = res.data.rows;
    list.filter(f => {
      f.templateContent = JSON.parse(f.templateContent);
    });
    var html = '';
    let number = 190;
    let changeHeight = number;
    let changeWidth = number;
    let change = 0;
    list.filter((f, index) => {
      html += '<div style="position: relative;text-align: center;text-align: -webkit-center;float: left;' +
        labelWidth + ';height: 245px;overflow: hidden;border: 1px solid #C9C9C9;cursor: pointer;" id="' + f.id + '">';
      html += '<div style="margin: 5px;height: 200px;width: 200px;background: #f7f7f7;overflow: hidden;">';
      if (f.templateWidth > f.templateHeight) {
        change = (number / (f.templateWidth * 10)).toFixed(2);
        changeHeight = f.templateHeight * 10 * number;
      } else {
        change = (number / (f.templateHeight * 10)).toFixed(2);
        changeWidth = f.templateWidth * 10 * number;
      }
      html += '<div style="background: #fff;position: relative;transform-origin: 10px 10px;'
        + 'border: 1px solid #F5711d;border-radius: 5px;width:' + f.templateWidth * 10 + 'px;height:' + f.templateHeight * 10
        + 'px;transform:scale(' + change + ',' + change + ')">';

      let html2 = '';
      //var templateImage = f.templateContent.paper.templateImage;
      var templateColor = f.templateContent.paper.templateColor;
      var bgStyle = 'width:' + f.templateWidth * 10 + 'px;height:' + f.templateHeight * 10 + 'px;';
      var bgobjShow = f.templateContent.paper.bgobjShow;
      /*if (templateImage) {
        bgStyle = bgStyle + 'background-image:url(/backend/images/labelTemplate/' + templateImage + '); background-repeat: no-repeat;';
      }*/
      if (templateColor) {
        bgStyle = bgStyle + 'background-color:' + templateColor + ';';
      }
      if (bgobjShow == 0) {
        bgStyle = bgStyle + 'opacity:' + 0 + ';';
      }
      html2 += '<div style="position: absolute;z-index: 0;' + bgStyle + '">';
      var bgobj = f.templateContent.paper.labelobjects.bgobj;
      if (bgobj) {
        bgobj.filter(k => {
          var publicHtml = 'left:' + k.l + 'px;top:' + k.t + 'px;width:'
            + k.w + 'px;height:' + k.h + 'px;';
          var styleHtml = (k.borderRadius ? 'border-radius:' + k.borderRadius + 'px' : '') //
            + (k.color ? ';background-color:' + k.color : '') // 背景颜色颜色;
            + (k.borderTopWidth ? ';border-top-width:' + k.borderTopWidth + 'px' : '')
            + (k.borderTopStyle ? ';border-top-style:' + k.borderTopStyle : '')
            + (k.borderTopColor ? ';border-top-color:' + k.borderTopColor : '')

            + (k.borderLeftWidth ? ';border-left-width:' + k.borderLeftWidth + 'px' : '')
            + (k.borderLeftStyle ? ';border-left-style:' + k.borderLeftStyle : '')
            + (k.borderLeftColor ? ';border-left-color:' + k.borderLeftColor : '')

            + (k.borderRightWidth ? ';border-right-width:' + k.borderRightWidth + 'px' : '')
            + (k.borderRightStyle ? ';border-right-style:' + k.borderRightStyle : '')
            + (k.borderRightColor ? ';border-right-color:' + k.borderRightColor : '')

            + (k.borderBottomWidth ? ';border-bottom-width:' + k.borderBottomWidth + 'px' : '')
            + (k.borderBottomStyle ? ';border-bottom-style:' + k.borderBottomStyle : '')
            + (k.borderBottomColor ? ';border-bottom-color:' + k.borderBottomColor : '');
          html2 += '<p style="position: absolute;' + publicHtml + styleHtml + '"></p>';
        });
      }
      html2 += '</div>';
      html += html2;

      var drawobj = f.templateContent.paper.labelobjects.drawobj;
      drawobj.filter(k => {
        var publicHtml = 'left:' + k.l + 'px;top:' + k.t + 'px;width:' + k.w + 'px;height:' + k.h + 'px;'
          + (k.transform ? 'transform:rotate(' + k.transform + 'deg);' : '');
        var styleHtml = 'font-size:' + k.fontsize + 'px;line-height:' + k.fontsize + 'px;font-family:' + k.fontfamily
          + (k.color ? ';color:' + k.color : '')
          + (k.textAlign ? ';text-align:' + k.textAlign : '')
          + (k.fontbold == true ? ';font-weight:bold;' : '')
          + (k.fontitalic == true ? ';font-style:italic' : '')
          + (k.fontunderline == true ? ';text-decoration:underline' : '')
          + (k.fontstrikeout == true ? ';text-decoration:line-through' : '');

        if (k.text) {
          if (k.itemtype == 8) {
            html += '<div style="position: absolute;' + publicHtml + 'background-color:' + k.color + '">&nbsp;</div>';
          } else if (k.text.datasource == "nbyaohang2") {//南北药行
            html += '<img src=' + require("../../static/images/nbyaohang2.png") + ' alt="" style="position: absolute;' + publicHtml + '">';
          } else if (k.text.datasource == "shenzhenwujia") {// 章
            html += '<img src=' + require("../../static/images/shenzhenwujia.png") + ' alt="" style="position: absolute;' + publicHtml + '">';
          } else if (k.text.datasource == "barcode_img") {//条码
            html += '<img src=' + require("../../static/images/barCode.png") + ' alt="" style="position: absolute;' + publicHtml + '">';
          } else if (k.text.datasource == "qrcode_img") {//二维码
            html += '<img src=' + require("../../static/images/QRCode.png") + ' alt="" style="position: absolute;' + publicHtml + '">';
          } else if (k.text.datasource == "goods_img") {// 商品图片
            html += '<img src=' + require("../../static/images/picture.png") + ' alt="" style="position: absolute;' + publicHtml + '">';
          } else if (k.text.keyinput == 0 || k.text.datasource == "time" || k.text.datasource == "date"
            || k.text.datasource == "promotionBeginTime" || k.text.datasource == "promotionEndTime") {
            html += '<span style="white-space: nowrap;position: absolute;' + publicHtml + styleHtml + '">' + k.text.value + '</span>';
          } else {
            html += '<p style="position: absolute;' + publicHtml + styleHtml + '">' + k.text.value + '</p>';
          }
        } else {
          html += '<table style="border: 1px solid black;position: absolute;' + publicHtml + '">';
          html += '<tr style="border: 1px solid black;text-align: center;vertical-align: inherit;height:' + k.heights[0] + 'px">';
          for (var z in k.columnNames) {
            html += '<th style="border: 1px solid black;text-align: center;vertical-align: inherit;width:' + k.widths[z] + 'px;">' + k.columnNames[z] + '</th>';
          }
          html += '</tr>';
          for (var i = 0; i < k.tableLine - 1; i++) {
            html += '<tr style="border: 1px solid black;text-align: center;vertical-align: inherit;height:' + k.heights[i + 1] + 'px">';
            for (var j = 0; j < k.tableRow; j++) {
              html += '<td style="border: 1px solid black;text-align: center;vertical-align: inherit;">' + k.datas[i][j] + '</td>';
            }
            html += '</tr>';
          }
          html += '</table>';
        }
      });
      html += '</div>';
      html += '</div>';
      html += '<h5 style="text-align: center;font-size: 12px;line-height: 30px;">'
        + f.templateName + '（' + f.templateWidth + '*' + f.templateHeight + '）</h5>';
      html += '</div>';
    });
    ref.labelRef.innerHTML = html;
  }).catch((err) => {
    _this.loading = false;
  });
}


// 设置ip名称 -- 设置ip
const getIPs = (callback) => {
  var ip_dups = {};
  var RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
  var useWebKit = !!window.webkitRTCPeerConnection;
  var mediaConstraints = {
    optional: [{ RtpDataChannels: true }]
  };
  // 这里就是需要的ICEServer了
  var servers = {
    iceServers: [
      { urls: "stun:stun.services.mozilla.com" },
      { urls: "stun:stun.l.google.com:19302" },
    ]
  };
  var pc = new RTCPeerConnection(servers, mediaConstraints);
  function handleCandidate(candidate) {
    var ip_regex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/;
    var hasIp = ip_regex.exec(candidate);
    if (hasIp) {
      var ip_addr = ip_regex.exec(candidate)[1];
      if (ip_dups[ip_addr] === undefined)
      callback(ip_addr);
      ip_dups[ip_addr] = true;
    }
  }
  // 网络协商的过程
  pc.onicecandidate = function (ice) {
  if (ice.candidate) {
    handleCandidate(ice.candidate.candidate);
  }
  };
  pc.createDataChannel("");
  //创建一个SDP(session description protocol)会话描述协议 是一个纯文本信息 包含了媒体和网络协商的信息
  pc.createOffer(function (result) {
    pc.setLocalDescription(result, function () { }, function () { });
  }, function () { });
  setTimeout(() => {
    var sdp = pc.localDescription ? pc.localDescription.sdp : '';
    var lines = sdp.split('\n');
    lines.forEach(function (line) {
      if (line.indexOf('a=candidate:') === 0)
      handleCandidate(line);
    });
  }, 1500);
}

if (isPC() && !isGlasses()) {
  getIPs((ip) => {
  	localStorage.setItem('ip', ip);

    // 设置名称
    const userAgent = navigator.userAgent;
    const browserNameRegexMap = {
      chrome: /Chrome\/([\d.]+)/,
      safari: /Version\/([\d.]+).*Safari/,
      firefox: /Firefox\/([\d.]+)/,
      ie: /MSIE\s([\d.]+)/,
      edge: /Edge\/([\d.]+)/,
      opera: /OPR\/([\d.]+)/
    };

    for (const [browserName, regex] of Object.entries(browserNameRegexMap)) {
      const match = userAgent.match(regex);
      if (match) {
        window.localStorage.setItem('hostName', (isPC() ? "PC端_" : '网页端') + browserName + "_" + match[1]);
      }
    }
  });
}

// 登录，登出记录编辑
export function pconlineFn (_this, onlined) {
  if (!isPC() || isGlasses()) return false;
  let loginInfo = _this.$store.state.loginInfo;
  let info = {
    diskSerialNumber: window.localStorage.getItem('deviceId'),// 对应登录的deviceId，机器唯一值
    shopId: loginInfo.shopId,
    userId: loginInfo.userId,
    userName: loginInfo.user.nickname,
    pcType: 0,// 0：PC端。1：手机端
    onlined: onlined,// 0：在线。1：退出
    hostAddress: window.localStorage.getItem('ip'),
    hostName: window.localStorage.getItem('hostName')
  }
  _this.$http.post(interfaceFn() + '/pconline/edit', qs.stringify(info), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then((res) => {
    // console.log(res);
  });
}

export function setZoom(scale) {
  scale = scale / 100;
  document.getElementById('app').style.zoom = scale;
}

export function showUDI(name) {
  return isMedicine() ? '追溯码' : name || 'UDI标识码';
}



// WEBPACK FOOTER //
// ./src/assets/util.js